<template>
  <div>
    <!-- <CCard columns class="card-columns cols-2"> -->
    <div class="mb-3">
      <CRow class="mb-3">
        <div class="col-lg-4 col-md-12">
          <label class="typo__label font-weight-bold"> Partner </label>
          <multiselect
            v-model="partnerSelected"
            placeholder="Seleccione un Partner"
            label="value"
            track-by="id"
            :options="partners"
            :close-on-select="true"
            :clear-on-select="false"
            :multiple="false"
            :taggable="false"
          ></multiselect>
          <!-- @input="getfilterPartner()" -->
        </div>
        <div class="col-lg-4 col-md-12">
          <label class="typo__label font-weight-bold"> Location </label>
          <treeselect
            v-if="!isLoading"
            v-model="locationSelected"
            :multiple="true"
            :options="locations1[0]"
            @input="getfilterlocationNamenew()"
          />
          <!-- :load-options="loadOptions" -->
        </div>
        <!-- <div class="col-md-4">
          <label class="typo__label font-weight-bold"> Location </label>
          <multiselect
            v-model="locationSelected"
            placeholder="Seleccione un Location"
            :custom-label="customLabel"
            track-by="locationName"
            :options="locations"
            :close-on-select="true"
            :clear-on-select="false"
            @input="getfilterlocationName()"
            :multiple="true"
            :taggable="true"
            
          ></multiselect>
        </div> -->
        <div class="col-lg-4 col-md-12">
          <div>
            <label class="typo__label font-weight-bold">Date Created</label>
          </div>
          <date-picker
            v-model="range"
            range
            :shortcuts="shortcuts"
            confirm
            @change="dateSelected(range)"
          ></date-picker>
        </div>
      </CRow>
      <CRow>
        <div class="col-lg-4 col-md-12">
          <label class="typo__label font-weight-bold"> ScoreTag </label>
          <multiselect
            v-model="scoretagSelected"
            placeholder="Seleccione un ScoreTag"
            label="name"
            track-by="name"
            :options="scoreTags"
            :close-on-select="true"
            :clear-on-select="false"
            @input="getfilterscoreTag()"
            :multiple="true"
            :taggable="true"
          ></multiselect>
        </div>
        <div class="col-lg-4 col-md-12">
          <label class="typo__label font-weight-bold"> Rating </label>
          <multiselect
            v-model="starratingSelected"
            placeholder="Seleccione un Rating"
            label="name"
            track-by="name"
            :options="starRatings"
            :close-on-select="true"
            :clear-on-select="false"
            @input="getfilterstarRating()"
            :multiple="true"
            :taggable="true"
          ></multiselect>
        </div>
        <!-- <div class="col-md-4">
          <label class="typo__label font-weight-bold"> Topics </label>
          <multiselect
            v-model="topicSelected"
            placeholder="Seleccione un Topic"
            label="category_name"
            track-by="category_name"
            :options="topics"
            :close-on-select="true"
            :clear-on-select="false"
            @input="getfilterTopic()"
            :multiple="true"
            :taggable="true"
          ></multiselect>
        </div> -->

        <!-- @input="getfilterlocationNamePartner()" -->
      </CRow>
    </div>
    <CRow> </CRow>
    <CRow>
      <CCol lg="6" md="12">
        <CCard>
          <div>
            <div v-if="loader_barchartDatasets1">
              <semipolar-spinner
                :animation-duration="2000"
                :size="80"
                color="blue"
              ></semipolar-spinner>
            </div>
            <div v-else id="chart-container">
              <apexchart
                :height="500"
                :options="apex_dataconfig_data_radar.dataSource.chartOptions"
                :series="apex_dataconfig_data_radar.dataSource.series"
              ></apexchart>
            </div>
          </div>
          <!--  <div v-if="loader_scoretagcommentCount">
            <semipolar-spinner
              :animation-duration="2000"
              :size="80"
              color="blue"
            ></semipolar-spinner>
          </div>
          <div v-else>
            <CDataTable
              :items="scoretagcommentCount"
              hover
              striped
              bordered
              large
              fixed
              pagination
              :loading="isLoadingdata"
              :fields="fields_data"
              caption="Different Values"
            />
          </div> -->
          <!-- </CCol> -->
        </CCard>
      </CCol>
      <!-- <CCol class="col-6"> -->
      <CCol lg="6" md="12">
        <CCard>
          <CCardHeader
            >Graph with Sentiment Analysis (Score) results
          </CCardHeader>
          <CCardBody>
            <div v-if="loader_donutDatasets">
              <semipolar-spinner
                :animation-duration="2000"
                :size="80"
                color="blue"
              ></semipolar-spinner>
            </div>
            <div v-else>
              <highcharts
                class="chart"
                :options="graph_barChartSentimentAnalysisSpline"
              ></highcharts>
            </div>
            <!-- "['P', 'P+', 'NONE', 'N', 'NEU', 'N+']" -->
          </CCardBody>
        </CCard>
      </CCol>
      <!-- </CCol> -->
    </CRow>

    <!-- ANCHOR new two table widget of best and worst location -->
    <CRow>
      <div class="col-lg-6 col-md-12">
        <CCard>
          <CCardBody>
            <label
              ><b><i>Top 5 Location By Best Average Rating</i></b></label
            >
            <CDataTable
              :items="locationBestPartnerData"
              hover
              striped
              bordered
              large
              fixed
              pagination
              :loading="locationBestPartnerLoading"
              :fields="locationPartnerColumns"
              caption="Location By Best Average Rating"
            />
          </CCardBody>
        </CCard>
      </div>
      <div class="col-lg-6 col-md-12">
        <CCard>
          <CCardBody>
            <label
              ><b><i>Top 5 Location By Worst Average Rating</i></b></label
            >
            <CDataTable
              :items="locationWorstPartnerData"
              hover
              striped
              bordered
              large
              fixed
              pagination
              :loading="locationWorstPartnerLoading"
              :fields="locationPartnerColumns"
              caption="Location By Worst Average Rating"
            />
          </CCardBody>
        </CCard>
      </div>
    </CRow>
    <!-- Ends -->

    <!-- ANCHOR new two location graph widget of best and worst location rating -->
    <CRow style="display: none">
      <div class="col-md-6">
        <CCard>
          <CCardBody>
            <label
              ><b><i>Top 10 Best Location Rating</i></b></label
            >
            <div v-if="graph_TenBestLocationRatingLoader">
              <semipolar-spinner
                :animation-duration="2000"
                :size="80"
                color="blue"
              ></semipolar-spinner>
            </div>
            <div v-else>
              <highcharts
                class="chart"
                :options="graph_TenBestLocationRating"
              ></highcharts>
            </div>
          </CCardBody>
        </CCard>
      </div>
      <div class="col-md-6">
        <CCard>
          <CCardBody>
            <label
              ><b><i>Top 10 Worst Location Rating</i></b></label
            >
            <div v-if="graph_TenWorstLocationRatingLoader">
              <semipolar-spinner
                :animation-duration="2000"
                :size="80"
                color="blue"
              ></semipolar-spinner>
            </div>
            <div v-else>
              <highcharts
                class="chart"
                :options="graph_TenWorstLocationRating"
              ></highcharts>
            </div>
          </CCardBody>
        </CCard>
      </div>
    </CRow>
    <!-- Ends -->
    <CRow>
      <CCol class="col-12 p-3">
        <CCard>
          <CCardBody>
            <CDataTable
              :items="tableGreenRedMarkDataValues"
              :fields="tableGreenRedMarkColumnValues"
              hover
              striped
              bordered
              large
              fixed
              pagination
              :loading="tableGreenRedMarkDataLoading"
              caption="Location By Green red"
            />
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CCard>
      <CRow>
        <CCol class="col-12 p-3">
          <div v-if="loader_barchart">
            <semipolar-spinner
              :animation-duration="2000"
              :size="80"
              color="blue"
            ></semipolar-spinner>
          </div>
          <div v-else class="barChart col-md-12">
            <!-- <bar-chart
              :height="300"
              :width="1000"
              :chart-data="barchartDatacollection.datasets"
              :labels="barchartDatacollection.labels"
            ></bar-chart>  -->
            <apexchart
              :height="400"
              :options="apex_f_dataconfig_data.dataSource.chartOptions"
              :series="apex_f_dataconfig_data.dataSource.series"
            ></apexchart>
            <!-- <CChartBar
              style="height:400px"
              :datasets="barchartDatacollection.datasets"
              :labels="barchartDatacollection.labels"
              :options="{ maintainAspectRatio: false }"
            /> -->
          </div>
        </CCol>
      </CRow>
    </CCard>
    <CCard>
      <CRow>
        <CCol class="col-12 p-3">
          <semipolar-spinner
            :animation-duration="2000"
            :size="30"
            color="blue"
            v-if="isLoading_apex_data"
          ></semipolar-spinner>
          <div id="chart-container" v-if="!isLoading_apex_data">
            <apexchart
              :height="400"
              :options="apex_dataconfig_data.dataSource.chartOptions"
              :series="apex_dataconfig_data.dataSource.series"
            ></apexchart>
          </div>
        </CCol>
      </CRow>
    </CCard>

    <CCol>
      <CRow class="p-0">
        <CCol lg="6" md="12" class="pl-0 pr-2">
          <CCard>
            <div v-if="loader_piechartDatasets">
              <semipolar-spinner
                :animation-duration="2000"
                :size="80"
                color="blue"
              ></semipolar-spinner>
            </div>
            <div v-else>
              <CChartPie
                :datasets="piechartDatasets"
                :labels="label_pie_chart"
                legendposition="right"
              />
            </div>
          </CCard>
        </CCol>

        <CCol lg="6" md="12" class="pl-2 pr-0">
          <CCard>
            <div id="chart-container">
              <div v-if="loader_barchartDatasets1">
                <semipolar-spinner
                  :animation-duration="2000"
                  :size="80"
                  color="blue"
                ></semipolar-spinner>
              </div>
              <div v-else>
                <CChartBar
                  :height="300"
                  :width="400"
                  :datasets="barchartDatasets1"
                  :labels="label_barchart1"
                />
              </div>
            </div>
          </CCard>
        </CCol>
      </CRow>
    </CCol>

    <!-- <CCard>
      <CRow>
        <CCol class="col-12 p-3">
          <CCol sm="12">
            <CDataTable
              :items="insights"
              hover
              striped
              bordered
              small
              fixed
              pagination
              :loading="isLoading"
              :fields="fields_data_star_rating"
            >
              <template #createTime="{ item }">
                <td>
                  {{ item.createTime | formatDate }}
                </td>
              </template>
            </CDataTable>
          </CCol>
        </CCol>
      </CRow>
    </CCard> -->
    <CCard>
      <CRow>
        <CCol class="col-12 p-3">
          <CCol sm="12">
            <div v-if="loader_barchartDatasets2">
              <semipolar-spinner
                :animation-duration="2000"
                :size="80"
                color="blue"
              ></semipolar-spinner>
            </div>
            <div v-else class="w-clip-chart">
              <!-- <CChartBar
                :height="300"
                :width="1000"
                :datasets="barchartDatasets2"
                :labels="label_barchart2"
              /> -->
              <!-- <label style="text-align:center;margin: 0 auto;display: block;"
                ><b>Topics Identified</b></label
              > -->
              <highcharts
                class="chart chart-cliped"
                :options="graph_wordcloud"
              ></highcharts>
            </div>
          </CCol>
        </CCol>
      </CRow>
    </CCard>
    <CCard>
      <CRow>
        <CCol class="col-12 p-3">
          <CCol sm="12" style="height: 500px; overflow-y: auto">
            <div v-if="loader_insights">
              <semipolar-spinner
                :animation-duration="2000"
                :size="80"
                color="blue"
              ></semipolar-spinner>
            </div>
            <div v-else>
              <CDataTable
                :items="insights"
                hover
                striped
                bordered
                fixed-header
                small
                column-filter
                sorter
                :loading="isLoadingdata"
                :fields="fields_data_large"
              >
                <!-- pagination -->
                <template #createTime="{ item }">
                  <td>
                    {{ item.createTime | formatDate }}
                  </td>
                </template>
                <template #location_id="{ item }">
                  <td>
                    {{ item.location_id[1] }}
                  </td>
                </template>
              </CDataTable>
            </div>
            <div v-if="loadMore">
              <scroll-loader
                :loader-method="getstarRatingandCommentData"
                :loader-enable="loadMore"
              >
                <semipolar-spinner
                  :animation-duration="2000"
                  :size="30"
                  color="blue"
                ></semipolar-spinner>
              </scroll-loader>
            </div>
          </CCol>
        </CCol>
      </CRow>
    </CCard>
  </div>
</template>

<script>
import Vue from "vue";
import _ from 'lodash';
import store from "../../store";

import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/scss/index.scss";

import { CChartDoughnut, CChartPie, CChartBar } from "@coreui/vue-chartjs";
import BarChart from "./Barchart.js";

import VueApexCharts from "vue-apexcharts";
import Multiselect from "vue-multiselect";
import moment from "moment";
import { SemipolarSpinner } from "epic-spinners";

import { LOAD_CHILDREN_OPTIONS } from "@riophae/vue-treeselect";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ScrollLoader from "vue-scroll-loader";

export default {
  name: "Insight",
  components: {
    // ...Charts,
    DatePicker,
    DateRangePicker,
    CChartDoughnut,
    CChartPie,
    CChartBar,
    BarChart,
    apexchart: VueApexCharts,
    Multiselect,
    SemipolarSpinner,
    Treeselect,

    // FCComponent
  },
  updated(){
    //console.log(this.locationBestPartnerData)
    //console.log("localizaciones ",this.locations)
    //console.log("partner seleccionado ",this.partnerSelected)
    /*console.log("2 " + this.tableGreenRedMarkDataValues)
    console.log(this.locations)*/
  },
  data() {
    var today = new Date();
    var yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    var last7days = new Date(today);
    last7days.setDate(last7days.getDate() - 6);
    var lastmonth = new Date(today);
    lastmonth.setMonth(lastmonth.getMonth() - 1);
    return {
      demographicExcludeSelected: [],
      countriesIncludes: [
        {
          name: "Spain",
          id: 68,
          label: "Spain",
          code: "ES",
          children: null,
        },
      ],
      isLoading_apex_data: false,
      loader_scoretagcommentCount: false,
      loader_donutDatasets: false,
      loader_insights: false,
      loader_barchart: false,
      loader_piechartDatasets: false,
      loader_barchartDatasets1: false,

      loader_barchartDatasets2: false,
      loader_barchartDatasets2: false,
      loader_apex_radar: false,

      date: "",
      time: "",
      range: "",
      insights: [],
      loadMore: false,
      isLoadingdata: false,
      offset_insight: 0,
      insightsLocation: [],
      insightsArray: [],
      partners: [],
      partnersArray: [],
      analyzeinsightfirst: [],
      analyzeinsightfirstArray: [],
      analyzeinsightthird: [],
      analyzeinsightthirdArray: [],
      analyzeinsightfourth: [],
      analyzeinsightfourthArray: [],
      analyzeinsightfifth: [],
      analyzeinsightfifthArray: [],

      analyzeinsightfirstLocation: [],
      analyzeinsightthirdLocation: [],
      analyzeinsightfourthLocation: [],
      analyzeinsightfifthLocation: [],

      categories: [],
      partnerSelected: "",
      locations: [],
      locations1: [[]],
      locations2: [
        {
          id: "fruits",
          label: "Fruits",
          children: [
            {
              id: "apple",
              label: "Apple",
              isNew: true,
            },
            {
              id: "grapes",
              label: "Grapes",
            },
            {
              id: "pear",
              label: "Pear ",
            },
            {
              id: "strawberry",
              label: "Strawberry",
            },
            {
              id: "watermelon",
              label: "Watermelon",
            },
          ],
        },
        {
          id: "vegetables",
          label: "Vegetables",
          children: [
            {
              id: "corn",
              label: "Corn ",
            },
            {
              id: "carrot",
              label: "Carrot ",
            },
            {
              id: "eggplant",
              label: "Eggplant",
            },
            {
              id: "tomato",
              label: "Tomato",
            },
          ],
        },
      ],
      locationsArray: [],
      locationSelected: [],
      scoreTags: [],
      scoreTagsArray: [],
      scoretagSelected: "",
      starRatings: [
        { name: 1, value: 1 },
        { name: 2, value: 2 },
        { name: 3, value: 3 },
        { name: 4, value: 4 },
        { name: 5, value: 5 },
      ],
      form_unique: [],
      form_uniqueSelected: "",
      starRatingsArray: [],
      starratingSelected: "",
      starratingSelectedValue: "",
      topics: [],
      topics_data: [],
      topicsArray: [],
      topicSelected: "",
      isLoading: false,
      isLoadingdata: false,
      commentCount: [],
      scoretagcommentCount: [],
      commentCountLocation: [],
      commentCountArray: [],
      score_data: [],
      score_dataArray: [],
      global_yearlyReviews: [],
      barchartscoredata: [],
      barchartscoredata_label: [],
      apexdata_label: [],
      apexdata_radar_label: [],
      dataset_apexchart: [],
      dataset_radar_apexchart: [],
      topic_starrating_data: [],
      topic_avg_starrating_data: [],
      form_count_data: [],
      topic_form_data: [],
      partner_ids: "",
      shortcuts: [
        {
          text: "Today",
          onClick: () => {
            this.range = [today, today];
          },
        },
        {
          text: "YesterDay",
          onClick: () => {
            this.range = [yesterday, yesterday];
          },
        },
        {
          text: "Last 7 Days",
          onClick: () => {
            this.range = [last7days, last7days];
          },
        },
        {
          text: "Last Month",
          onClick: () => {
            this.range = [lastmonth, lastmonth];
          },
        },
      ],
      timePickerOptions: {
        start: "00:00",
        step: "00:30",
        end: "23:30",
      },
      apex_dataconfig_data: {
        dataSource: {},
      },
      apex_f_dataconfig_data: {
        dataSource: {},
      },
      apex_dataconfig_data_radar: { dataSource: {} },
      // barchartDatacollection: { labels:{}, data:{}, options:{}},
      barchartDatacollection: { labels: [], datasets: [] },
      options_bar: {
        scales: {
          xAxes: [
            {
              stacked: true,
              // gridLines: { display: true }
            },
          ],
          yAxes: [
            {
              stacked: true,
            },
          ],
        },
        legend: { display: true },
        // height: "100%",
        // width: "100%"
      },
      fields_data: [
        { key: "location_label", label: "Location" },
        { key: "score_tag", label: "Score Tag" },
        { key: "count", label: "Comment" },
      ],
      fields_data_large: [
        { key: "createTime", label: "Date" },
        { key: "location_id", label: "Location" },
        { key: "score_tag", label: "Score Tag" },
        { key: "starRating", label: "StarRating" },
        { key: "comment", label: "Original comment" },
        { key: "comment_eng", label: "Comment" },
      ],
      fields_data_star_rating: [
        { key: "create_time", label: "Date" },
        { key: "location_name", label: "Location" },
        { key: "star_rating", label: "Star Rating" },
        { key: "comment", label: "Original comment" },
        { key: "comment_eng", label: "Comment" },
      ],
      // apex_data:{},
      apex_data: {
        series: [],
        chartOptions: {},
      },
      apex_f_data: {
        series: [],
        chartOptions: {},
      },
      apex_data_radar: {
        series: [],
        chartOptions: {},
      },
      // ANCHOR Location Best Partner
      locationBestPartnerData: [],
      locationBestPartnerLoading: false,
      locationPartnerColumns: [
        { key: "location_description", label: "Location Name" },
        { key: "averageRating", label: "Average Rating" },
      ],
      // ANCHOR Location Worst Partner
      locationWorstPartnerData: [],
      locationWorstPartnerLoading: false,

      // ANCHOR Sentimental Bar Chart
      graph_barChartSentimentAnalysisSpline: {
        chart: {
          zoomType: "xy",
        },
        title: {
          text: "",
        },
        xAxis: [
          {
            categories: [],
            crosshair: true,
          },
        ],
        yAxis: [
          {
            // Primary yAxis
            labels: {
              format: "{value}%",
            },
            title: {
              text: "Star Rating(%)",
            },
            opposite: true,
          },
          {
            // Secondary yAxis
            gridLineWidth: 0,
            title: {
              text: "Star Rating",
            },
            labels: {
              format: "{value}",
            },
          },
        ],
        credits: false,
        tooltip: {
          shared: true,
        },
        legend: {
          layout: "horizontal",
          align: "center",
          backgroundColor: "rgba(255,255,255,0.25)",
        },
        series: [
          {
            name: "Score Result(s)",
            type: "column",
            yAxis: 1,
            color: "#FB963E",
            data: [],
            tooltip: {
              valueSuffix: " ",
            },
          },
          {
            name: "Score Result %",
            type: "spline",
            color: "#595959",
            data: [],
            tooltip: {
              valueSuffix: "%",
            },
          },
        ],
      },

      // Sentiment Analysis Grpah Configurable Options
      _d_graph_barChartSentimentAnalysisOptionsXaxisDataPoint: [],
      _d_graph_barChartSentimentAnalysisOptionsDataColumns: [],
      _d_graph_barChartSentimentAnalysisOptionsPercentColumns: [],

      // ANCHOR Word Cloud Chart
      graph_wordcloud: {
        series: [
          {
            type: "wordcloud",
            // rotation: {
            //   from: 0,
            //   to: 0,
            //   orientations: 0,
            // },
            data: [
              // {
              //   name: "Lorem",
              //   weight: 8,
              // },
              // {
              //   name: "Ipsum",
              //   weight: 9,
              // },
              // {
              //   name: "Dolor",
              //   weight: 10,
              // },
              // {
              //   name: "Sit",
              //   weight: 7,
              // },
              // {
              //   name: "Ammet",
              //   weight: 6,
              // },
              // {
              //   name: "S",
              //   weight: 5,
              // },
              // {
              //   name: "w",
              //   weight: 4,
              // },
              // {
              //   name: "q",
              //   weight: 3,
              // },
              // {
              //   name: "wqw",
              //   weight: 2,
              // },
              // {
              //   name: "32",
              //   weight: 1,
              // },
            ],
            name: "Occurrences",
            placementStrategy: "random",
            // minFontSize: 20,
          },
        ],
        title: {
          text: "Topics Identified",
        },
      },
      _d_graph_wordcloud_series: [],

      // ANCHOR Ten Best Rating Locations
      tenBestRaingLocations: [],
      graph_TenBestLocationRating: {
        chart: {
          zoomType: "xy",
        },
        title: {
          text: "",
        },
        xAxis: [
          {
            categories: [],
            crosshair: true,
          },
        ],
        yAxis: [
          {
            // Primary yAxis
            labels: {
              format: "{value}",
            },
            title: {
              text: "Review Star Rating Avg",
            },
            opposite: true,
          },
          {
            // Secondary yAxis
            gridLineWidth: 0,
            title: {
              text: "Location Rating",
            },
            labels: {
              format: "{value}",
            },
          },
        ],
        credits: false,
        tooltip: {
          shared: true,
        },
        legend: {
          layout: "horizontal",
          align: "center",
          backgroundColor: "rgba(255,255,255,0.25)",
        },
        series: [
          {
            name: "Location Rating",
            type: "column",
            color: "#5700FF",
            yAxis: 1,
            data: [],
            tooltip: {
              valueSuffix: "",
            },
          },
          {
            name: "Review Star Rating Avg",
            type: "spline",
            color: "#595959",
            data: [],
            tooltip: {
              valueSuffix: "",
            },
          },
        ],
      },
      graph_TenBestLocationRatingLoader: false,
      // ANCHOR Ten Worst Rating Locations
      tenWorstRaingLocations: [],
      graph_TenWorstLocationRating: {
        chart: {
          zoomType: "xy",
        },
        title: {
          text: "",
        },
        xAxis: [
          {
            categories: [],
            crosshair: true,
          },
        ],
        yAxis: [
          {
            // Primary yAxis
            labels: {
              format: "{value}",
            },
            title: {
              text: "Review Star Rating Avg",
            },
            opposite: true,
          },
          {
            // Secondary yAxis
            gridLineWidth: 0,
            title: {
              text: "Location Rating",
            },
            labels: {
              format: "{value}",
            },
          },
        ],
        credits: false,
        tooltip: {
          shared: true,
        },
        legend: {
          layout: "horizontal",
          align: "center",
          backgroundColor: "rgba(255,255,255,0.25)",
        },
        series: [
          {
            name: "Location Rating",
            type: "column",
            yAxis: 1,
            color: "#FB963E",
            data: [],
            tooltip: {
              valueSuffix: " ",
            },
          },
          {
            name: "Review Star Rating Avg",
            type: "spline",
            color: "#595959",
            data: [],
            tooltip: {
              valueSuffix: "",
            },
          },
        ],
      },
      graph_TenWorstLocationRatingLoader: false,

      // ANCHOR State Table Green Red Mark Data
      tableGreenRedMarkData: [],
      tableGreenRedMarkDataValues: [],
      tableGreenRedMarkColumnValues: [],
    };
  },

  mounted() {
    // this.getstarRating();
    // this.getCategoryNameTopics();
    // this.getdatastudioSentiment();
    // this.getdatastudioTopics();
    // this.locations1=[];
    this.getPartners();
    // this.getCountries();

    // this.getcommentCount();
    // this.getanalyzeInsightFirst();
    // this.getanalyzeInsightThird();
    // this.getanalyzeInsightFourth();
    // this.getanalyzeInsightFifth();
  },
  computed: {
    computedItems() {
      return insights.map((item) => {
        return {
          ...item,
          created_time: item.created_time,
          // registeredDate: item.registered.date
        };
      });
    },

    scoreTaglabel() {
      var scoretag_sorted = _.sortBy(this.score_data, "score_tag").reverse();
      return scoretag_sorted.map((item) => {
        if (item.score_tag != false) {
          // console.log("item label :: ", item);
          return item.score_tag;
        }
      });
    },
    piechartDatasets() {
      // console.log("this.topic_starrating_data :::::: ", this.topic_starrating_data);
      var backgroundColor = [
        "#5700ff",
        "#b08fff",
        "#D3C5FF",
        "#7c7c7c",
        "#3d3d3d",
        "#eeff41",
        "#FAFF99",
        "#CCCCCC",
      ];
      var hoverBackgroundColor = [
        "#5700ff",
        "#b08fff",
        "#D3C5FF",
        "#7c7c7c",
        "#3d3d3d",
        "#eeff41",
        "#FAFF99",
        "#CCCCCC",
      ];
      var topic_starrating_data_sorted = _.sortBy(
        this.topic_starrating_data,
        "category_id[1]"
      ).reverse();
      this.topic_starrating_data.forEach((category, index) => {
        // console.log(
        //   "this.topic_starrating_data category",
        //   category.category_id[1]
        // );
        if (category.category_id != false) {
          if (category.category_id[1].split(" ")[1] === "Time") {
            backgroundColor[index] = "#eeff41";
            hoverBackgroundColor[index] = "#eeff41";
          }
          if (category.category_id[1].split(" ")[1] === "Price") {
            backgroundColor[index] = "#3d3d3d";
            hoverBackgroundColor[index] = "#3d3d3d";
          }
          if (category.category_id[1].split(" ")[1] === "Place") {
            backgroundColor[index] = "#D3C5FF";
            hoverBackgroundColor[index] = "#D3C5FF";
          }
          if (category.category_id[1].split(" ")[1] === "Location") {
            backgroundColor[index] = "#b08fff";
            hoverBackgroundColor[index] = "#b08fff";
          }
          if (category.category_id[1].split(" ")[1] === "Brand") {
            backgroundColor[index] = "#5700ff";
            hoverBackgroundColor[index] = "#5700ff";
          }
          if (category.category_id[1].split(" ")[1] === "Products") {
            backgroundColor[index] = "#7c7c7c";
            hoverBackgroundColor[index] = "#7c7c7c";
          }
          if (category.category_id[1].split(" ")[1] === "Staff") {
            backgroundColor[index] = "#CCCCCC";
            hoverBackgroundColor[index] = "#CCCCCC";
          }
          if (category.category_id[1] === "Others") {
            backgroundColor[index] = "#FAFF99";
            hoverBackgroundColor[index] = "#FAFF99";
          }
        }
      });
      // console.log("this.topic_starrating_data category", backgroundColor);
      return [
        {
          backgroundColor: backgroundColor,
          data: this.topic_starrating_data.map((item) => {
            // console.log("item.category_id", item.category_id);
            if (item.category_id != false) return item.__count;
          }),
        },
      ];
    },
    barchartDatasets1() {
      return [
        {
          label: "Star Rating by group logic",
          backgroundColor: "#5700ff",
          data: this.topic_avg_starrating_data.map((item) => {
            if (item.category_id != false) return item.review_star_rating_avg;
          }),
          options: {
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    min: 0,
                  },
                },
              ],
            },
          },
        },
      ];
    },
    label_barchart1() {
      return this.topic_avg_starrating_data.map((item) => {
        if (item.category_id != false) return item.category_id[1];
      });
    },
    label_pie_chart() {
      //  console.log("topic_starrating_data ::: ",this.topic_starrating_data);

      return this.topic_starrating_data.map((item) => {
        if (item.category_id != false) return item.category_id[1];
      });
    },
    barchartDatasets2() {
      return [
        {
          label: "Topics Identified",
          backgroundColor: "#5700ff",
          data: this.form_count_data.map((item) => {
            return item.__count;
          }),
          options: {
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                  },
                },
              ],
            },
          },
        },
      ];
    },
    label_barchart2() {
      // //console.log("this.topics" , this.form_count_data);
      return this.form_count_data.map((item) => {
        return item.Form;
      });
    },
  },
  methods: {
    getfilterscoreTag() {
      // this.scoretagSelected = "";
      // this.topicSelected = [];
      // this.starratingSelected = [];
      // this.range= [];
      this.insightArray = [];
      this.insight = [];
      this.offset_insight = 0;
      this.insights = [];
      this.insightsArray = [];
      this.categories = [];

      var score_tags = [];
      this.scoretagSelected.forEach((score_tag) => {
        score_tags.push(score_tag.name);
      });
      //  console.log("score_tags :::: ",score_tags);
      if (this.scoretagSelected.length > 0) {
        this.getscoretagcommentCount();
        this.getsentimentanalysisCount();
        this.getstarRatingandCommentData();
        this.getscoretagratingovertime();
        this.getcategoryratingovertime();
        this.gettopicstarratingCount();
        this.gettopicavgstarratingCount();
        this.getformdataCount();
        // this.getlocationbyBestPartner();
        // this.getlocationbyWorstPartner();
        this.getTableGreenRedMarkData();
      } else {
        if (this.locationSelected.length > 0 || this.partner_ids.length > 0) {
          this.getscoretagcommentCount();
          this.getsentimentanalysisCount();
          this.getstarRatingandCommentData();
          this.getscoretagratingovertime();
          this.getcategoryratingovertime();
          this.gettopicstarratingCount();
          this.gettopicavgstarratingCount();
          this.getformdataCount();
          // this.getlocationbyBestPartner();
          // this.getlocationbyWorstPartner();
          this.getTableGreenRedMarkData();
        } else {
          this.locations = [];
          this.locationSelected = [];
          this.businessunitSelected = [];
          this.businessUnits = [[]];
          this.scoretagcommentCount = [];
          this.score_data = [];
          this.insights = [];
          this.category = [];
          this.barchartscoredata_label = [];
          this.barchartDatacollection.label = [];
          this.apexdata = [];
          this.locationWorstPartnerData = [];
          this.locationWorstPartnerData = [];
          this.tableGreenRedMarkData = [];
          this.apex_dataconfig_data = {
            dataSource: {
              type: "bar",
              chartOptions: {
                chart: {
                  type: "bar",
                  height: 300,
                  stacked: true,
                  toolbar: {
                    show: true,
                  },
                  zoom: {
                    enabled: true,
                  },
                },
              },
            },
          };
          this.apex_f_dataconfig_data = {
            dataSource: {
              type: "bar",
              chartOptions: {
                chart: {
                  type: "bar",
                  height: 300,
                  stacked: true,
                  toolbar: {
                    show: true,
                  },
                  zoom: {
                    enabled: true,
                  },
                },
              },
            },
          };
          this.apex_dataconfig_data_radar = {
            dataSource: {
              type: "radar",
              chartOptions: {
                chart: {
                  type: "radar",
                  height: 300,
                },
              },
            },
          };
          this.barchartDatacollection = {
            labels: [],
            datasets: [],
            options: {},
          };
          this.topic_avg_starrating_data = [];
          this.dataset_apexchart = [];
          this.apexdata_label = [];
          this.barchartscoredata_label = [];
          this.form_count_data = [];
          this.topic_form_data = [];
          this.topic_starrating_data = [];
          this.starRatings = [
            { name: 1, value: 1 },
            { name: 2, value: 2 },
            { name: 3, value: 3 },
            { name: 4, value: 4 },
            { name: 5, value: 5 },
          ];
          this.scoreTags = [];
          this.topics = [];
          this.starratingSelected = [];
          this.topicSelected = [];
        }
      }
    },
    getfilterTopic() {
      // this.scoretagSelected = "";
      // // this.topicSelected = "";
      // this.starratingSelected = [];
      // this.range= "";
      this.insightArray = [];
      this.insight = [];
      this.categories = [];

      this.offset_insight = 0;
      this.insights = [];
      this.insightsArray = [];

      var topics = [];
      this.topicSelected.forEach((topic) => {
        topics.push(topic.category_name);
      });
      // this.topic_ids =to
      //  console.log("topic array here==>", topics);

      if (this.topicSelected.length > 0) {
        this.getscoretagcommentCount();
        this.getsentimentanalysisCount();
        this.getstarRatingandCommentData();
        this.getscoretagratingovertime();
        this.getcategoryratingovertime();
        this.gettopicstarratingCount();
        this.gettopicavgstarratingCount();
        this.getformdataCount();
        // this.getlocationbyBestPartner();
        // this.getlocationbyWorstPartner();
        this.getTableGreenRedMarkData();
      } else {
        if (this.locationSelected.length > 0 || this.partner_ids.length > 0) {
          this.getscoretagcommentCount();
          this.getsentimentanalysisCount();
          this.getstarRatingandCommentData();
          this.getscoretagratingovertime();
          this.getcategoryratingovertime();
          this.gettopicstarratingCount();
          this.gettopicavgstarratingCount();
          this.getformdataCount();
          // this.getlocationbyBestPartner();
          // this.getlocationbyWorstPartner();
          this.getTableGreenRedMarkData();
        } else {
          this.locations = [];
          this.locationSelected = [];
          this.businessunitSelected = [];
          this.businessUnits = [[]];
          this.scoretagcommentCount = [];
          this.score_data = [];
          this.insights = [];
          this.category = [];
          this.barchartscoredata_label = [];
          this.barchartDatacollection.label = [];
          this.apexdata = [];
          this.tableGreenRedMarkData = [];
          this.locationWorstPartnerData = [];
          this.locationWorstPartnerData = [];
          this.apex_dataconfig_data = {
            dataSource: {
              type: "bar",
              chartOptions: {
                chart: {
                  type: "bar",
                  height: 300,
                  stacked: true,
                  toolbar: {
                    show: true,
                  },
                  zoom: {
                    enabled: true,
                  },
                },
              },
            },
          };
          this.apex_dataconfig_l_data = {
            dataSource: {
              type: "bar",
              chartOptions: {
                chart: {
                  type: "bar",
                  height: 300,
                  stacked: true,
                  toolbar: {
                    show: true,
                  },
                  zoom: {
                    enabled: true,
                  },
                },
              },
            },
          };
          this.apex_dataconfig_data_radar = {
            dataSource: {
              type: "radar",
              chartOptions: {
                chart: {
                  type: "radar",
                  height: 300,
                },
              },
            },
          };
          this.barchartDatacollection = {
            labels: [],
            datasets: [],
            options: {},
          };
          this.topic_avg_starrating_data = [];
          this.dataset_apexchart = [];
          this.apexdata_label = [];
          this.barchartscoredata_label = [];
          this.form_count_data = [];
          this.topic_form_data = [];
          this.topic_starrating_data = [];
          this.starRatings = [
            { name: 1, value: 1 },
            { name: 2, value: 2 },
            { name: 3, value: 3 },
            { name: 4, value: 4 },
            { name: 5, value: 5 },
          ];
          this.scoreTags = [];
          this.topics = [];
          this.starratingSelected = [];
          this.topicSelected = [];
        }
      }
    },
    getfilterstarRating() {
      //  console.log("here starratingSelected",  this.starratingSelected.length );
      // this.locationSelected = "";
      // this.partnerSelected = "";
      // this.scoretagSelected = "";
      // this.topicSelected = "";
      // // this.starratingSelected = [];
      // this.range= "";
      this.insightArray = [];
      this.insight = [];
      this.offset_insight = 0;
      this.insights = [];
      this.insightsArray = [];
      this.categories = [];

      var starRatings = [];
      var ratingSelected = this.starratingSelected;

      this.starratingSelected.forEach((rating) => {
        starRatings.push(rating.value);
      });
      this.starratingSelectedValue = starRatings;
      //  console.log("starRatings ########", starRatings);
      if (starRatings.length > 0) {
        this.getscoretagcommentCount();
        this.getsentimentanalysisCount();
        this.getstarRatingandCommentData();
        this.getscoretagratingovertime();
        this.getcategoryratingovertime();
        this.gettopicstarratingCount();
        this.gettopicavgstarratingCount();
        this.getformdataCount();
        // this.getlocationbyBestPartner();
        // this.getlocationbyWorstPartner();
        this.getTableGreenRedMarkData();
      } else {
        // console.log("this.partnerSelected None::::: ");
        if (this.locationSelected.length > 0 || this.partner_ids.length > 0) {
          this.getscoretagcommentCount();
          this.getsentimentanalysisCount();
          this.getstarRatingandCommentData();
          this.getscoretagratingovertime();
          this.getcategoryratingovertime();
          this.gettopicstarratingCount();
          this.gettopicavgstarratingCount();
          this.getformdataCount();
          // this.getlocationbyBestPartner();
          // this.getlocationbyWorstPartner();
          this.getTableGreenRedMarkData();
        } else {
          this.locations = [];
          this.locationSelected = [];
          this.businessunitSelected = [];
          this.businessUnits = [[]];
          this.scoretagcommentCount = [];
          this.score_data = [];
          this.insights = [];
          this.category = [];
          this.barchartscoredata_label = [];
          this.barchartDatacollection.label = [];
          this.apexdata = [];
          this.tableGreenRedMarkData = [];
          this.locationBestPartnerData = [];
          this.locationWorstPartnerData = [];
          this.apex_dataconfig_data = {
            dataSource: {
              type: "bar",
              chartOptions: {
                chart: {
                  type: "bar",
                  height: 300,
                  stacked: true,
                  toolbar: {
                    show: true,
                  },
                  zoom: {
                    enabled: true,
                  },
                },
              },
            },
          };
          this.apex_f_dataconfig_data = {
            dataSource: {
              type: "bar",
              chartOptions: {
                chart: {
                  type: "bar",
                  height: 300,
                  stacked: true,
                  toolbar: {
                    show: true,
                  },
                  zoom: {
                    enabled: true,
                  },
                },
              },
            },
          };
          this.apex_dataconfig_data_radar = {
            dataSource: {
              type: "radar",
              chartOptions: {
                chart: {
                  type: "radar",
                  height: 300,
                },
              },
            },
          };
          this.barchartDatacollection = {
            labels: [],
            datasets: [],
            options: {},
          };
          this.topic_avg_starrating_data = [];
          this.dataset_apexchart = [];
          this.apexdata_label = [];
          this.barchartscoredata_label = [];
          this.form_count_data = [];
          this.topic_form_data = [];
          this.topic_starrating_data = [];
          this.starRatings = [
            { name: 1, value: 1 },
            { name: 2, value: 2 },
            { name: 3, value: 3 },
            { name: 4, value: 4 },
            { name: 5, value: 5 },
          ];
          this.scoreTags = [];
          this.topics = [];
          this.starratingSelected = [];
          this.topicSelected = "";
        }
      }
    },
    customLabel({ locationName, city, description }) {
      return `${locationName} – ${city} – ${description}`;
    },
    getfilterlocationName() {
      this.scoretagSelected = "";
      this.starratingSelected = "";
      this.topicSelected = "";
      this.range = "";
      this.insightArray = [];
      this.insight = [];
      this.offset_insight = 0;
      this.insights = [];
      this.insightsArray = [];

      var location_names = [];
      var location_names_city = [];
      var location_names_desc = [];
      this.locationSelected.forEach((location) => {
        var key =
          location.locationName +
          " - " +
          location.city +
          " - " +
          location.description;
        location_names.push(key);
        location_names_city.push(location.city);
        location_names_desc.push(location.description);
      });
      // this.demographicExcludeSelected.forEach((location) => {
      //   location_names.push(location.locationName);
      //   location_names_city.push(location.city);
      //   location_names_desc.push(location.description);
      // });
      //  console.log(location_names, location_names_city, location_names_desc, "@@@@@location_names");
      var comment_data = this.commentCountArray;
      var insights = this.insightsArray;
      var analyzeinsightfirst = this.analyzeinsightfirstArray;
      var analyzeinsightthird = this.analyzeinsightthirdArray;
      var analyzeinsightfifth = this.analyzeinsightfifthArray;
      var analyzeinsightfourth = this.analyzeinsightfourthArray;
      //console.log("filtered_data4 before :::: ", analyzeinsightthird.length);

      if (this.locationSelected.length > 0) {
        // var query = {location_name: this.locationSelected.location_name, city: this.locationSelected.city, description : this.locationSelected.description};

        // function search(data){
        //   return Object.keys(this).every((key) => data[key].includes(this[key]));
        // }
        //  console.log(comment_data.length, location_names, "   comment_data.length");

        var filtered_data_comment = comment_data.filter((item) => {
          //  console.log(item, location_names.includes(item.location_name +' - '+item.location_id.city +' - '+item.location_id.description), "location_names.includes(item.location_name +' - '+item.location_id.city +' - '+item.location_id.description)");
          // return location_names.includes(item.location_name);
          return location_names.includes(
            item.location_name +
              " - " +
              item.location_id.city +
              " - " +
              item.location_id.description
          );
        });
        //  console.log(filtered_data_comment.length, "   filtered_data_comment.length");

        // this.commentCount = filtered_data_comment;

        // var result_comment_data = comment_data.filter(search, query);
        // console.log("location_names, location_names_city, location_names_desc", location_names, location_names_city, location_names_desc, comment_data);
        // var filtered_data_comment = comment_data.filter(item =>{
        //   //  console.log(location_names.includes(item.locationName) && location_names_city.includes(item.city) && location_names_desc.includes(item.description) ,"==============> ");
        //  location_names.includes(item.locationName) && location_names_city.includes(item.city) && location_names_desc.includes(item.description)});

        // console.log("result_comment_data ::::: ", filtered_data_comment.length);
        this.commentCount = filtered_data_comment;

        var filtered_data_insight = insights.filter((item) => {
          //  console.log("item in Insight", item);
          // return location_names.includes(item.location_name);
          return location_names.includes(
            item.location_name +
              " - " +
              item.location_id.city +
              " - " +
              item.location_id.description
          );
        });
        this.insights = filtered_data_insight;

        var filtered_data_first = analyzeinsightfirst.filter((item) => {
          // return location_names.includes(item.location_name);
          return location_names.includes(
            item.location_name +
              " - " +
              item.location_id.city +
              " - " +
              item.location_id.description
          );
        });
        var analyzeinsightfirst_sorted = _.sortBy(
          filtered_data_first,
          "location_name"
        );
        this.analyzeinsightfirst = analyzeinsightfirst_sorted;

        this.getComment_scoretagcount(analyzeinsightfirst_sorted);
        this.getscoretagratingovertime1(analyzeinsightfirst_sorted);
        this.getComment_count(analyzeinsightfirst_sorted);

        var filtered_data3 = analyzeinsightthird.filter((item) => {
          // return location_names.includes(item.location_name);
          return location_names.includes(
            item.location_name +
              " - " +
              item.location_id.city +
              " - " +
              item.location_id.description
          );
        });
        // //console.log("filtered_data3  after:::: ", filtered_data3.length);

        var analyzeinsightthird_sorted = _.sortBy(
          filtered_data3,
          "location_name"
        );
        this.analyzeinsightthird = filtered_data3;

        this.getscoretagratingovertime2(analyzeinsightthird_sorted);
        this.getscoretagratingovertime_category(analyzeinsightthird_sorted);
        this.apex_dataConfig();
        this.apex_radar_dataConfig();
        this.gettopic_starratingcount(analyzeinsightthird_sorted);
        this.gettopic_starratingcount1(analyzeinsightthird_sorted);

        var filtered_data_fourth = analyzeinsightfourth.filter((item) => {
          // return location_names.includes(item.location_name);
          return location_names.includes(
            item.location_name +
              " - " +
              item.location_id.city +
              " - " +
              item.location_id.description
          );
        });
        var analyzeinsightfourth_sorted = _.sortBy(
          filtered_data_fourth,
          "location_name"
        );
        this.analyzeinsightfourth = analyzeinsightfourth_sorted;

        var filtered_data_fifth = analyzeinsightfifth.filter((item) => {
          // return location_names.includes(item.location_name);
          return location_names.includes(
            item.location_name +
              " - " +
              item.location_id.city +
              " - " +
              item.location_id.description
          );
        });
        var forms = [];
        var analyzeinsightfifth_sorted = _.sortBy(filtered_data_fifth, "form");
        //console.log("after filter analyzeinsightfifth_sorted :::::::: ",analyzeinsightfifth_sorted);
        this.analyzeinsightfifth = filtered_data_fifth;

        this.commentCountLocation = filtered_data_comment;
        this.insightsLocation = filtered_data_insight;
        this.analyzeinsightfirstLocation = analyzeinsightfirst_sorted;
        this.analyzeinsightthirdLocation = analyzeinsightthird_sorted;
        this.analyzeinsightfourthLocation = analyzeinsightfourth_sorted;
        this.analyzeinsightfifthLocation = analyzeinsightfourth_sorted;

        analyzeinsightfifth_sorted.forEach((item) => {
          if (item.form !== false) forms.push(item.form);
        });
        this.getuniqueforms(forms);
        this.getformcount(analyzeinsightfifth_sorted);
      } else {
        this.insights = insights;
        this.commentCount = comment_data;
        var analyzeinsightfirst_sorted = _.sortBy(
          analyzeinsightfirst,
          "location_name"
        );

        this.getComment_scoretagcount(analyzeinsightfirst_sorted);
        this.getscoretagratingovertime1(analyzeinsightfirst_sorted);
        this.getComment_count(analyzeinsightfirst_sorted);

        var analyzeinsightthird_sorted = _.sortBy(
          analyzeinsightthird,
          "location_name"
        );

        this.getscoretagratingovertime2(analyzeinsightthird_sorted);
        this.getscoretagratingovertime_category(analyzeinsightthird_sorted);
        this.apex_dataConfig();
        this.apex_radar_dataConfig();
        this.gettopic_starratingcount(analyzeinsightthird_sorted);
        this.gettopic_starratingcount1(analyzeinsightthird_sorted);

        var analyzeinsightfourth_sorted = _.sortBy(
          analyzeinsightfourth,
          "location_name"
        );
        this.analyzeinsightfourth = analyzeinsightfourth_sorted;

        var analyzeinsightfifth_sorted = _.sortBy(analyzeinsightfifth, "form");

        var forms = [];
        analyzeinsightfifth_sorted.forEach((item) => {
          if (item.form !== false) forms.push(item.form);
        });
        this.getuniqueforms(forms);
        this.getformcount(analyzeinsightfifth_sorted);
      }
    },

    getfilterlocationNamenew() {
      //  console.log("here ",  this.locationSelected, this.partnerSelected );
      // this.locationSelected ="";
      // this.scoretagSelected = [];
      // this.starratingSelected = [];
      // this.topicSelected = [];
      // this.range= [];
      this.offset_insight = 0;
      this.insights = [];
      this.insightsArray = [];
      this.categories = [];

      // if(this.locationSelected.length > 0){
      if (this.locationSelected.length > 0) {
        //  console.log("this.locationSelected ::: ", this.locationSelected);
        this.getscoretagcommentCount();
        this.getsentimentanalysisCount();
        this.getstarRatingandCommentData();
        this.getscoretagratingovertime();
        this.getcategoryratingovertime();
        this.gettopicstarratingCount();
        this.gettopicavgstarratingCount();
        this.getformdataCount();
        this.getlocationbyBestPartner();
        
        this.getlocationbyWorstPartner();
        this.getTableGreenRedMarkData();
      } else {
        // console.log("this.partnerSelected None::::: ");
        if (this.partner_ids.length > 0) {
          this.getscoretagcommentCount();
          this.getsentimentanalysisCount();
          this.getstarRatingandCommentData();
          this.getscoretagratingovertime();
          this.getcategoryratingovertime();
          this.gettopicstarratingCount();
          this.gettopicavgstarratingCount();
          this.getformdataCount();
          this.getlocationbyBestPartner();
          
          this.getlocationbyWorstPartner();
          this.getTableGreenRedMarkData();
        } else {
          this.locations = [];
          this.locationSelected = [];
          this.businessunitSelected = [];
          this.businessUnits = [[]];
          this.scoretagcommentCount = [];
          this.score_data = [];
          this.insights = [];
          this.category = [];
          this.barchartscoredata_label = [];
          this.barchartDatacollection.label = [];
          this.apexdata = [];

          this.tableGreenRedMarkData = [];
          this.locationBestPartnerData = [];
          this.locationWorstPartnerData = [];
          this.apex_dataconfig_data = {
            dataSource: {
              type: "bar",
              chartOptions: {
                chart: {
                  type: "bar",
                  height: 300,
                  stacked: true,
                  toolbar: {
                    show: true,
                  },
                  zoom: {
                    enabled: true,
                  },
                },
              },
            },
          };
          this.apex_f_dataconfig_data = {
            dataSource: {
              type: "bar",
              chartOptions: {
                chart: {
                  type: "bar",
                  height: 300,
                  stacked: true,
                  toolbar: {
                    show: true,
                  },
                  zoom: {
                    enabled: true,
                  },
                },
              },
            },
          };
          this.apex_dataconfig_data_radar = {
            dataSource: {
              type: "radar",
              chartOptions: {
                chart: {
                  type: "radar",
                  height: 300,
                },
              },
            },
          };
          this.barchartDatacollection = {
            labels: [],
            datasets: [],
            options: {},
          };
          this.topic_avg_starrating_data = [];

          this.dataset_apexchart = [];

          this.apexdata_label = [];
          this.barchartscoredata_label = [];
          this.form_count_data = [];
          this.topic_form_data = [];
          this.topic_starrating_data = [];
          this.starRatings = [];
          this.scoreTags = [];
          this.topics = [];
          this.starratingSelected = [];
          this.topicSelected = [];
          this.tableGreenRedMarkData = [];
        }
      }
    },

    dateSelected(date) {
      this.offset_insight = 0;
      this.insights = [];
      this.insightsArray = [];
      this.categories = [];

      // this.scoretagSelected = [];
      // this.starratingSelected = [];
      // this.topicSelected = [];
      if (date[0] !== null || date[1] !== null) {
        this.getscoretagcommentCount();
        this.getsentimentanalysisCount();
        this.getstarRatingandCommentData();
        this.getscoretagratingovertime();
        this.getcategoryratingovertime();
        this.gettopicstarratingCount();
        this.gettopicavgstarratingCount();
        this.getformdataCount();
        // this.getlocationbyBestPartner();
        // this.getlocationbyWorstPartner();
        this.getTableGreenRedMarkData();
      } else {
        if (this.locationSelected.length > 0 || this.partner_ids.length > 0) {
          this.getscoretagcommentCount();
          this.getsentimentanalysisCount();
          this.getstarRatingandCommentData();
          this.getscoretagratingovertime();
          this.getcategoryratingovertime();
          this.gettopicstarratingCount();
          this.gettopicavgstarratingCount();
          this.getformdataCount();
          // this.getlocationbyBestPartner();
          // this.getlocationbyWorstPartner();
          this.getTableGreenRedMarkData();
        } else {
          this.locations = [];
          this.locationSelected = [];
          this.businessunitSelected = [];
          this.businessUnits = [[]];
          this.scoretagcommentCount = [];
          this.score_data = [];
          this.insights = [];
          this.category = [];
          this.barchartscoredata_label = [];
          this.barchartDatacollection.label = [];
          this.apexdata = [];
          this.locationWorstPartnerData = [];
          this.locationBestPartnerData = [];
          this.apex_dataconfig_data = {
            dataSource: {
              type: "bar",
              chartOptions: {
                chart: {
                  type: "bar",
                  height: 300,
                  stacked: true,
                  toolbar: {
                    show: true,
                  },
                  zoom: {
                    enabled: true,
                  },
                },
              },
            },
          };
          this.apex_f_dataconfig_data = {
            dataSource: {
              type: "bar",
              chartOptions: {
                chart: {
                  type: "bar",
                  height: 300,
                  stacked: true,
                  toolbar: {
                    show: true,
                  },
                  zoom: {
                    enabled: true,
                  },
                },
              },
            },
          };
          this.apex_dataconfig_data_radar = {
            dataSource: {
              type: "radar",
              chartOptions: {
                chart: {
                  type: "radar",
                  height: 300,
                },
              },
            },
          };
          this.barchartDatacollection = {
            labels: [],
            datasets: [],
            options: {},
          };
          this.topic_avg_starrating_data = [];

          this.dataset_apexchart = [];

          this.apexdata_label = [];
          this.barchartscoredata_label = [];
          this.form_count_data = [];
          this.topic_form_data = [];
          this.topic_starrating_data = [];

          // this.demographicExcludeSelected=[];
          this.starRatings = [];
          this.scoreTags = [];
          this.topics = [];
          this.starratingSelected = [];
          this.topicSelected = "";
          this.tableGreenRedMarkData = [];
        }
      }
    },
    resetanalyzeinsightFirst(analyzeinsightfirst) {
      var start = this.range[0];
      var end = this.range[1];
      if (analyzeinsightfirst.length > 0) {
        // filtered_comment =;
        //console.log("before filter analyzeinsightfirst :::::::: ",analyzeinsightfirst);
        var analyzeinsightfirst_sorted = analyzeinsightfirst;
        if (start !== null || end !== null) {
          var filtered_data = analyzeinsightfirst.filter((item) => {
            return (
              moment(item.create_time) >= moment(start) &&
              moment(item.create_time) <= moment(end)
            );
          });

          analyzeinsightfirst_sorted = _.sortBy(filtered_data, "location_name");
        } else {
          analyzeinsightfirst_sorted = _.sortBy(
            analyzeinsightfirst,
            "location_name"
          );
        }
        this.getComment_scoretagcount(analyzeinsightfirst_sorted);
        this.getscoretagratingovertime1(analyzeinsightfirst_sorted);
        this.getComment_count(analyzeinsightfirst_sorted);

        //console.log("afterfilter analyzeinsightfirst_sorted:::::::: ",analyzeinsightfirst_sorted.length);

        // //console.log("after filter :::::::: ",filtered_data);
      }
    },
    resetanalyzeinsightThird(analyzeinsightthird) {
      var start = this.range[0];
      var end = this.range[1];
      if (analyzeinsightthird.length > 0) {
        // filtered_comment =;
        //  console.log("before filter analyzeinsightthird111111 :::::::: ",analyzeinsightthird);
        var analyzeinsightthird_sorted = analyzeinsightthird;
        if (start !== null || end !== null) {
          var filtered_data3 = analyzeinsightthird.filter((item) => {
            return (
              moment(item.create_time) >= moment(start) &&
              moment(item.create_time) <= moment(end)
            );
          });
          analyzeinsightthird_sorted = _.sortBy(
            filtered_data3,
            "location_name"
          );
        }
        //console.log("after filter analyzeinsightthird :::::::: ",analyzeinsightthird);

        this.getscoretagratingovertime2(analyzeinsightthird_sorted);
        this.getscoretagratingovertime_category(analyzeinsightthird_sorted);
        this.apex_dataConfig();
        this.apex_radar_dataConfig();
        this.gettopic_starratingcount(analyzeinsightthird_sorted);
        this.gettopic_starratingcount1(analyzeinsightthird_sorted);
      }
    },
    resetanalyzeinsightFourth(analyzeinsightfourth) {
      var start = this.range[0];
      var end = this.range[1];
      if (analyzeinsightfourth.length > 0) {
        //console.log("before filter analyzeinsightfourth :::::::: ",analyzeinsightfourth);
        var filtered_data4 = analyzeinsightfourth;
        if (start !== null || end !== null) {
          var filtered_data4 = analyzeinsightfourth.filter((item) => {
            return (
              moment(item.create_time) >= moment(start) &&
              moment(item.create_time) <= moment(end)
            );
          });
        }
        this.analyzeinsightfourth = filtered_data4;
      }
    },
    resetanalyzeinsightFifth(analyzeinsightfifth) {
      var start = this.range[0];
      var end = this.range[1];
      if (analyzeinsightfifth.length > 0) {
        //console.log("before filter analyzeinsightfifth :::::::: ",analyzeinsightfifth);
        var analyzeinsightfifth_sorted = analyzeinsightfifth;
        var forms = [];
        if (start !== null || end !== null) {
          var filtered_data5 = analyzeinsightfifth.filter((item) => {
            return (
              moment(item.create_time) >= moment(start) &&
              moment(item.create_time) <= moment(end)
            );
          });
          analyzeinsightfifth_sorted = _.sortBy(filtered_data5, "form");
          //console.log("after filter analyzeinsightfifth_sorted :::::::: ",analyzeinsightfifth_sorted);

          analyzeinsightfifth_sorted.forEach((item) => {
            if (item.form !== false) forms.push(item.form);
          });
        }

        this.getuniqueforms(forms);

        this.getformcount(analyzeinsightfifth_sorted);
      }
    },
    resetInsight(insights) {
      var start = this.range[0];
      var end = this.range[1];
      if (insights.length > 0) {
        //console.log("before filterinsight :::::::: ",insights);
        if (start !== null || end !== null) {
          var filtered_data_insight = insights.filter((item) => {
            return (
              moment(item.create_time) >= moment(start) &&
              moment(item.create_time) <= moment(end)
            );
          });
          this.insights = filtered_data_insight;
          //console.log("after filter insight :::::::: ",filtered_data_insight);
        } else {
          this.insights = insights;
        }
      }
    },
    resetCommentData(comment_data) {
      var start = this.range[0];
      var end = this.range[1];
      if (comment_data.length > 0) {
        // filtered_comment =;
        //  console.log("before filter comment_data :::::::: ",comment_data);
        if (start !== null || end !== null) {
          var filtered_data = comment_data.filter((item) => {
            return (
              moment(item.create_time) >= moment(start) &&
              moment(item.create_time) <= moment(end)
            );
          });
          this.commentCount = filtered_data;
          //  console.log("after filter comment_Data :::::::: ",filtered_data);
        } else {
          this.commentCount = comment_data;
        }
      }
    },

    async getlocation() {
      var gbalocation = store.getters.getlocationbyPartner;
      //  console.log( "item location1111 ::::::===>", gbalocation.length, this.isLoading );

      var options = [];
      // if (gbalocation.length === 0) {
      // this.isLoading = true;
      //  console.log("gbalocation 12", gbalocation.length);
      var partner_ids = this.partner_ids;
      //  console.log(partner_ids,"::::::::; partner_ids");
      store.dispatch("getlocationbyPartner", partner_ids).then(() => {
        gbalocation = store.getters.getlocationbyPartner;
        // console.log("gbalocation", gbalocation);
        // var gbalocation_sorted = _.sortBy(
        //   gbalocation,
        //   "location.partner_id.value"
        // );
        var locationsByPartner = [];

        var prev_key = "";
        var data = [];
        var data1 = [];
        //  console.log("gbalocation :::: ", gbalocation);
        gbalocation.map((location) => {
          //  console.log("@@@@!!!! :::: ", location);
          if (partner_ids.includes(location.partner_id[0])) {
            locationsByPartner.push(location);
            var custom_label =
              location.locationName +
              " - " +
              location.city +
              " - " +
              location.description;

            var key = location.partner_id[1];
            if (prev_key !== key) {
              //  console.log("@@@@@@@@@@@@@@2 main ", prev_key , key , data, custom_label);
              if (
                data.some((loc) => location.label === location.partner_id[1])
              ) {
                //  console.log("already_exists");
                var index1 = _.findIndex(data, {
                  label: location.partner_id[1],
                });
                data[index1].children.push({
                  id: location.id,
                  label: custom_label,
                  isNew: true,
                });
              } else {
                //  console.log("doesnot exists");
                data.push({
                  id: location.partner_id[0],
                  label: location.partner_id[1],
                  children: [
                    {
                      id: location.id,
                      label: custom_label,
                      isNew: true,
                    },
                  ],
                });
              }
              //  console.log("data ::: ", data);
              prev_key = key;
            } else {
              var index1 = _.findIndex(data, { label: location.partner_id[1] });
              //  console.log("!!!!!!!!!!1 ", prev_key ,index1,  key, data, data[index1]);

              data[index1].children.push({
                id: location.id,
                label: custom_label,
                isNew: true,
              });
              //  console.log(data[index1].children, key,  "data[index1].children", custom_label);
            }
          }
        });
        //  console.log("data ::: ", data);
        options.push(data);
        //  console.log("locationsByPartner ::::: ",options,  locationsByPartner.length);
        this.isLoading = false;

        // this.locations = _.sortBy(locationunique, "locationName");
        this.locations = _(locationsByPartner)
          .chain()
          .sortBy(function (location) {
            return location.locationName;
          })
          .sortBy(function (location) {
            return location.city;
          })
          .value();
        // this.locationsArray = _.sortBy(result, "locationName");
        this.locationsArray = _(locationsByPartner)
          .chain()
          .sortBy(function (location) {
            return location.locationName;
          })
          .sortBy(function (location) {
            return location.city;
          })
          .value();

        this.locations1 = options;
        // console.log("item location@@@: :::::===>", this.locations.length);
      });
    },
    async getlocationbyBestPartner() {
      var gbalocation = store.getters.getlocationbyPartner;
      var options = [];

      var partner_ids = [];
      var create_date = [];
      var location_ids = [];

      this.locationBestPartnerLoading = true;

      if (this.range !== null && this.range.length > 0) {
        if (this.range[0] !== null) {
          var start = moment(this.range[0]).format("YYYY-MM-DD");
          var end = moment(this.range[1]).format("YYYY-MM-DD");
          create_date.push(start);
          create_date.push(end);
        }
      }

      if (this.locationSelected.length > 0) {
        if (
          this.locationSelected.length === this.partner_ids.length &&
          this.locationSelected[0] === this.partner_ids[0]
        ) {
          partner_ids = this.partner_ids;
          
        } else {
          //  console.log("check businessunit and partner id length not same");
          partner_ids = this.partner_ids;
          location_ids = this.locationSelected;
        }
      } else {
        partner_ids = this.partner_ids;
      }
      
      var starRatings = [];
      if (this.starratingSelectedValue.length > 0) {
        starRatings = this.starratingSelectedValue;
      }

      var scoreTags = [];
      if (this.scoretagSelected.length > 0) {
        this.scoretagSelected.forEach((score_tag) => {
          scoreTags.push(score_tag.name);
        });
      }
      

      const payload = {
        partner_ids,
        location_ids: location_ids,
        create_date: create_date,
        scoreTags: scoreTags,
        starRatings: starRatings,
        sort: "averageRating desc",
        limit: 5,
      };
      
      //console.log("info-", "best", payload);
      //console.log("info del store" ,store.getters.getlocationbyBestPartner);
      store.dispatch("getlocationbyBestPartner", payload).then(() => {
        const getlocationbyBestPartner = store.getters.getlocationbyBestPartner;
        this.locationBestPartnerData = getlocationbyBestPartner;
        this.locationBestPartnerLoading = false;
      });
      //console.log("info-", "best", payload);
    },
    async getlocationbyWorstPartner() {
      var gbalocation = store.getters.getlocationbyPartner;
      var options = [];
      var partner_ids = [];
      var create_date = [];
      var location_ids = [];

      this.locationWorstPartnerLoading = true;

      if (this.range !== null && this.range.length > 0) {
        if (this.range[0] !== null) {
          var start = moment(this.range[0]).format("YYYY-MM-DD");
          var end = moment(this.range[1]).format("YYYY-MM-DD");
          create_date.push(start);
          create_date.push(end);
        }
      }

      if (this.locationSelected.length > 0) {
        if (
          this.locationSelected.length === this.partner_ids.length &&
          this.locationSelected[0] === this.partner_ids[0]
        ) {
          partner_ids = this.partner_ids;
        } else {
          //  console.log("check businessunit and partner id length not same");
          partner_ids = this.partner_ids;
          location_ids = this.locationSelected;
        }
      } else {
        partner_ids = this.partner_ids;
      }

      var starRatings = [];
      if (this.starratingSelectedValue.length > 0) {
        starRatings = this.starratingSelectedValue;
      }

      var scoreTags = [];
      if (this.scoretagSelected.length > 0) {
        this.scoretagSelected.forEach((score_tag) => {
          scoreTags.push(score_tag.name);
        });
      }
      //  console.log(partner_ids,"::::::::; partner_ids");
      const payload = {
        partner_ids,
        location_ids: location_ids,
        create_date: create_date,
        scoreTags: scoreTags,
        starRatings: starRatings,
        sort: "averageRating asc",
        limit: 5,
      };
      //console.log("info-", "worst", payload);
      store.dispatch("getlocationbyWorstPartner", payload).then(() => {
        const getlocationbyWorstPartner =
          store.getters.getlocationbyWorstPartner;
        this.locationWorstPartnerData = getlocationbyWorstPartner;
        this.locationWorstPartnerLoading = false;
      });
    },
    async getlocation12() {
      var gbalocation = store.getters.getlocationbyPartner;
      //console.log("partner_ids", this.partner_ids);
      //  console.log( "item location1111 ::::::===>", gbalocation.length, this.isLoading );

      var options = [];
      // if (gbalocation.length === 0) {
      // this.isLoading = true;
      //  console.log("gbalocation 12", gbalocation.length);
      var partner_ids = this.partner_ids;
      //  console.log(partner_ids,"::::::::; partner_ids");
      store.dispatch("getlocationbyPartner", partner_ids).then(() => {
        gbalocation = store.getters.getlocationbyPartner;
        //  console.log("gbalocation", gbalocation);
        var gbalocation_sorted = _.sortBy(
          gbalocation,
          "location.partner_id.name"
        );
        var locationsByPartner = [];

        var prev_key = "";
        var data = [];
        var data1 = [];
        //  console.log("gbalocation :::: ", gbalocation);
        gbalocation_sorted.map((location) => {
          // console.log("location.partner_id.id == partner_ids:::",location.partner_id.id , partner_ids);

          // if (partner_ids.includes(location.partner_id.id)) {
          //   locationsByPartner.push(location);

          //   //  console.log("locationsByPartner ::::: ", location,locationsByPartner);
          // }

          // console.log("partner_ids.includes(location.partner_id.id) :: ", partner_ids.includes(location.partner_id.id));
          if (partner_ids.includes(location.partner_id.id)) {
            locationsByPartner.push(location);
            var custom_label =
              location.locationName +
              " - " +
              location.city +
              " - " +
              location.description;

            var key = location.partner_id.name;
            if (prev_key !== key) {
              //  console.log("@@@@@@@@@@@@@@2 main ", prev_key , key , data, custom_label);
              if (data.some((loc) => loc.label === location.partner_id.name)) {
                //  console.log("already_exists");
                var index1 = _.findIndex(data, {
                  label: location.partner_id.name,
                });
                data[index1].children.push({
                  id: custom_label,
                  label: custom_label,
                  isNew: true,
                });
              } else {
                //  console.log("doesnot exists");
                data.push({
                  id: location.partner_id.name,
                  label: location.partner_id.name,
                  children: [
                    {
                      id: custom_label,
                      label: custom_label,
                      isNew: true,
                    },
                  ],
                });
              }
              // data={
              //   id: location.partner_id.name,
              //   label: location.partner_id.name,
              //   children: [{
              //     id: custom_label,
              //     label: custom_label,
              //     isNew: true,
              //   }],
              // };
              //  console.log("data ::: ", data);
              prev_key = key;
            } else {
              var index1 = _.findIndex(data, {
                label: location.partner_id.name,
              });
              //  console.log("!!!!!!!!!!1 ", prev_key ,index1,  key, data, data[index1]);

              data[index1].children.push({
                id: custom_label,
                label: custom_label,
                isNew: true,
              });
              //  console.log(data[index1].children, key,  "data[index1].children", custom_label);
            }
          }
        });
        //  console.log("data ::: ", data);
        options.push(data);
        //  console.log("locationsByPartner ::::: ",options,  locationsByPartner.length);
        // const locationunique = [
        //   ...new Map(
        //     locationsByPartner.map((item) => [item["locationName", "city"], item])
        //   ).values(),
        // ];
        // var result = locationsByPartner.filter(function (a) {
        //   var key = a.locationName + '|' + a.city + '|' + a.description;
        //       if (!this[key]) {
        //           this[key] = true;
        //           return true;
        //       }
        //   }, Object.create(null));

        this.isLoading = false;

        // this.locations = _.sortBy(locationunique, "locationName");
        this.locations = _(locationsByPartner)
          .chain()
          .sortBy(function (location) {
            return location.locationName;
          })
          .sortBy(function (location) {
            return location.city;
          })
          .value();
        // this.locationsArray = _.sortBy(result, "locationName");
        this.locationsArray = _(locationsByPartner)
          .chain()
          .sortBy(function (location) {
            return location.locationName;
          })
          .sortBy(function (location) {
            return location.city;
          })
          .value();

        this.locations1 = options;
        // console.log("item location@@@: :::::===>", this.locations.length);
      });
      // } else {
      //   this.isLoading = false;
      //   var partner_ids = this.partner_ids;
      //   var locationsByPartner = [];

      //   // gbalocation.map((location) => {
      //   //   if (partner_ids.includes(location.partner_id.id)) {
      //   //     locationsByPartner.push(location);
      //   //   //  console.log("locationsByPartner else ::::: ", location.locationName);
      //   //   }
      //   // });
      //   var prev_key = "";
      //   var data="";
      //   var gbalocation_sorted = _.sortBy(
      //       gbalocation,
      //       "locationName"
      //     );
      //   gbalocation_sorted.map((location) => {
      //   if (partner_ids.includes(location.partner_id.id)) {
      //         locationsByPartner.push(location);
      //         var custom_label = location.locationName +" - "+location.city +" - "+ location.description;

      //         var key = location.partner_id.name;
      //         //  console.log("location.partner_id.id", key,  custom_label);
      //           // if (prev_key !== key) {
      //           //   //  console.log("@@@@@@@@@@@@@@2 ", prev_key , data ,  key );
      //           //     data={
      //           //       id: location.partner_id.name,
      //           //       label: location.partner_id.name,
      //           //       children: [{
      //           //         id: custom_label,
      //           //         label: custom_label,
      //           //         isNew: true,
      //           //       }],
      //           //     };
      //           //     prev_key = key;
      //           // }else{
      //           //   var index1 = _.findIndex(data, {label: key});
      //           //   //  console.log("!!!!!!!!!!1 else ", prev_key , key );
      //           //   data.children.push({
      //           //         id: custom_label,
      //           //         label: custom_label,
      //           //         isNew: true,
      //           //       })
      //           // }

      //           if (prev_key !== key) {

      //             //  console.log("@@@@@@@@@@@@@@2 main ", prev_key , key , data);
      //             data.push({
      //                 id: location.partner_id.name,
      //                 label: location.partner_id.name,
      //                 children: [{
      //                   id: custom_label,
      //                   label: custom_label,
      //                   isNew: true,
      //                 }]
      //             });
      //               // data={
      //               //   id: location.partner_id.name,
      //               //   label: location.partner_id.name,
      //               //   children: [{
      //               //     id: custom_label,
      //               //     label: custom_label,
      //               //     isNew: true,
      //               //   }],
      //               // };
      //               //  console.log("data ::: ", data);
      //               prev_key = key;
      //           }else{
      //             var index1 = _.findIndex(data1, {label: key});
      //             //  console.log("!!!!!!!!!!1 ", prev_key ,index1,  key, data);

      //             data[index1].children.push({
      //                   id: custom_label,
      //                   label: custom_label,
      //                   isNew: true,
      //                 });
      //           }

      //          // var data = {
      //          //      id: location.partner_id.name,
      //          //      label: location.partner_id.name,
      //          //      children: [{
      //          //        id: custom_label,
      //          //        label: custom_label,
      //          //        isNew: true,
      //          //      }],
      //          //    };

      //       }

      //     });
      //       options.push(data);
      //   this.locations = _(locationsByPartner).chain().sortBy(function(location) {
      //                         return location.locationName;
      //                     }).sortBy(function(location) {
      //                         return location.city;
      //                     }).value();
      //   this.locationsArray = _(locationsByPartner).chain().sortBy(function(location) {
      //                         return location.locationName;
      //                     }).sortBy(function(location) {
      //                         return location.city;
      //                     }).value();
      //    this.locations1 = options;

      // }
    },
    async getPartners() {
      var partners = store.getters.getPartners;
      if (partners.length == 0) {
        this.isLoading = true;
        await store.dispatch("getPartners").then(() => {
          partners = store.getters.getPartners;
          this.partners = partners;
          this.partnersArray = partners;
          // this.partnerSelected.push(partners[0]);
          // this.getfilterPartner();

          //console.log("partners ::::::::: ",this.partners);
          return;
        });
      } else {
        this.partners = partners;
        this.partnersArray = partners;

        //console.log("partners ::::::::: ",partners);
        return;
      }
    },
    async getcommentCount() {
      var comment_count = store.getters.getcommentCount;
      if (comment_count.length == 0) {
        this.isLoading = true;
        await store.dispatch("getcommentCount").then(() => {
          comment_count = store.getters.getcommentCount;
          // this.partners = partners;
          // this.partnersArray = partners;
          //console.log("comment_count ::::::::: ",comment_count);
          return;
        });
      } else {
        // this.comment_count = comment_count;
        // this.comment_countArray = comment_count;

        //console.log("comment_count ::::::::: ",comment_count);
        return;
      }
    },
    async getanalyzeInsightFirst() {
      this.isLoading = true;
      var analyzeinsightfirst = [];
      var partner_ids = this.partner_ids;
      await store.dispatch("getanalyzeInsightFirst", partner_ids).then(() => {
        var analyzeinsightfirst = store.getters.getanalyzeInsightFirst;
        this.analyzeinsightfirst = analyzeinsightfirst;
        this.analyzeinsightfirstArray = analyzeinsightfirst;
        var analyzeinsightfirst_sorted = _.sortBy(
          analyzeinsightfirst,
          "location_name"
        );

        // //console.log("analyzeinsightfirst ::::::::: ",analyzeinsightfirst);
        this.getComment_scoretagcount(analyzeinsightfirst_sorted);
        this.getscoretagratingovertime1(analyzeinsightfirst_sorted);
        this.getComment_count(analyzeinsightfirst_sorted);
        return;
      });
    },
    async getanalyzeInsightThird() {
      // var analyzeinsightthird = store.getters.getanalyzeInsightThird;
      // if (analyzeinsightthird.length == 0) {
      this.isLoading = true;
      var analyzeinsightthird = [];
      var partner_ids = this.partner_ids;
      await store.dispatch("getanalyzeInsightThird", partner_ids).then(() => {
        var analyzeinsightthird = store.getters.getanalyzeInsightThird;
        this.analyzeinsightthird = analyzeinsightthird;
        this.analyzeinsightthirdArray = analyzeinsightthird;
        var analyzeinsightthird_sorted = _.sortBy(
          analyzeinsightthird,
          "category_name"
        );

        //console.log("analyzeinsightthird ::::::::: ",analyzeinsightthird);
        // analyzeinsightthird.forEach((thirddata)=>{
        // //console.log("thirddata.create_time, thirddata.category_name, thirddata.avg_star_rating",thirddata.create_time, thirddata.category_name, thirddata.avg_star_rating);
        // })
        this.getscoretagratingovertime2(analyzeinsightthird_sorted);
        this.getscoretagratingovertime_category(analyzeinsightthird_sorted);
        this.apex_dataConfig();
        this.apex_radar_dataConfig();
        this.gettopic_starratingcount(analyzeinsightthird_sorted);
        this.gettopic_starratingcount1(analyzeinsightthird_sorted);
        // this.getapexData(analyzeinsightthird_sorted);
        return;
      });
      // } else {
      //   this.analyzeinsightthird = analyzeinsightthird;
      //   this.analyzeinsightthirdArray = analyzeinsightthird;
      //   var analyzeinsightthird_sorted = _.sortBy(
      //     analyzeinsightthird,
      //     "category_name"
      //   );

      //   //console.log("analyzeinsightthird ::::::::: ",analyzeinsightthird_sorted);

      //   this.getscoretagratingovertime2(analyzeinsightthird_sorted);
      //   this.getscoretagratingovertime_category(analyzeinsightthird_sorted);
      //   this.apex_dataConfig();
      //   this.apex_radar_dataConfig();
      //   this.gettopic_starratingcount(analyzeinsightthird_sorted);
      //   this.gettopic_starratingcount1(analyzeinsightthird_sorted);
      //   return;
      // }
    },
    async getanalyzeInsightFourth() {
      // var analyzeinsightfourth = store.getters.getanalyzeInsightFourth;
      // if (analyzeinsightfourth.length == 0) {
      this.isLoading = true;
      var analyzeinsightfourth = [];
      var partner_ids = this.partner_ids;
      await store.dispatch("getanalyzeInsightFourth", partner_ids).then(() => {
        var analyzeinsightfourth = store.getters.getanalyzeInsightFourth;
        this.analyzeinsightfourth = analyzeinsightfourth;
        this.analyzeinsightfourthArray = analyzeinsightfourth;
        var analyzeinsightfourth_sorted = _.sortBy(
          analyzeinsightfourth,
          "category_name"
        );

        //console.log("analyzeinsightfourth111 ::::::::: ",analyzeinsightfourth_sorted);
        return;
      });
      // } else {
      //   this.analyzeinsightfourth = analyzeinsightfourth;
      //   this.analyzeinsightfourthArray = analyzeinsightfourth;
      //   var analyzeinsightfourth_sorted = _.sortBy(
      //     analyzeinsightfourth,
      //     "category_name"
      //   );

      //   //console.log("analyzeinsightfourth ::::::::: ",analyzeinsightfourth_sorted);
      //   return;
      // }
    },
    async getanalyzeInsightFifth() {
      // var analyzeinsightfifth = store.getters.getanalyzeInsightFifth;
      // if (analyzeinsightfifth.length == 0) {
      var analyzeinsightfifth = [];
      this.isLoading = true;
      var partner_ids = this.partner_ids;
      await store.dispatch("getanalyzeInsightFifth", partner_ids).then(() => {
        var analyzeinsightfifth = store.getters.getanalyzeInsightFifth;
        this.analyzeinsightfifth = analyzeinsightfifth;
        this.analyzeinsightfifth = analyzeinsightfifth;

        var analyzeinsightfifth_sorted = _.sortBy(analyzeinsightfifth, "form");
        var forms = [];
        analyzeinsightfifth_sorted.forEach((item) => {
          if (item.form !== false) forms.push(item.form);
        });

        this.getuniqueforms(forms);

        this.getformcount(analyzeinsightfifth_sorted);

        //console.log("analyzeinsightfifth222 ::::::::: ",analyzeinsightfifth_sorted);
        return;
      });
      // } else {
      //   this.analyzeinsightfifth = analyzeinsightfifth;
      //   this.analyzeinsightfifthArray = analyzeinsightfifth;
      //   //console.log("analyzeinsightfifth ::::::::: ",analyzeinsightfifth);

      //   var analyzeinsightfifth_sorted = _.sortBy(analyzeinsightfifth, "form");
      //   var forms = [];
      //   analyzeinsightfifth_sorted.forEach((item) => {
      //     if (item.form !== false)
      //       forms.push({ name: item.form, value: item.form });
      //   });
      //   this.getuniqueforms(forms);
      //   this.getformcount(analyzeinsightfifth_sorted);
      //   return;
      // }
    },
    async getdatastudioSentiment() {
      var insights = store.getters.getdatastudioSentiment;

      var starRatings = [];
      var scoreTags = [];
      // if (insights.length == 0) {
      this.isLoading = true;

      var partner_ids = this.partner_ids;
      await store.dispatch("getdatastudioSentiment", partner_ids).then(() => {
        insights = store.getters.getdatastudioSentiment;
        // this.insights = insights;

        var insights_sorted = _.sortBy(insights, "location_name");
        // //console.log("insights ::::::::: ", insights);
        this.insights = insights_sorted;
        this.insightsArray = insights_sorted;
        this.isLoading = false;
        return;
      });
    },
    // async getstarRating() {
    //   // var insightsStarRating = store.getters.getdatastudioSentimentStarRating;
    //   var partner_ids = this.partner_ids;
    //   var starRatings = [];
    //   var scoreTags = [];
    //   // if (insightsStarRating.length == 0) {
    //     this.isLoading = true;

    //     await store.dispatch("getdatastudioSentimentStarRating",partner_ids).then(() => {
    //       var insightsStarRating = store.getters.getdatastudioSentimentStarRating;

    //       var starRatingssorted = _.sortBy(insightsStarRating, "star_rating");
    //       var scoreTagsorted = _.sortBy(insightsStarRating, "score_tag");

    //       this.insightsStarRating = insightsStarRating;
    //       this.insightsStarRatingArray = insightsStarRating;

    //     // console.log("starRatingssorted", starRatingssorted);
    //       // var x =[1,2,3,4,5]
    //       // var filtered_data3 = starRatingssorted.filter((item) => {
    //       //   return x.includes(item.star_rating);
    //       // });
    //        const starRatingunique = [
    //         ...new Map(starRatingssorted.map((item) => [item["star_rating"], item])).values(),
    //       ];
    //       const scoreTagunique = [
    //         ...new Map(scoreTagsorted.map((item) => [item["score_tag"], item])).values(),
    //       ];
    //        // console.log("starRatingsunique", starRatingunique);
    //       var starRating =[];
    //       starRatingunique.forEach((star) => {
    //         if (star.star_rating !== false)
    //           starRating.push({
    //             name: star.star_rating,
    //             value: star.star_rating,
    //           });
    //         // if (topic.score_tag !== false)
    //         //   scoreTags.push({ name: topic.score_tag, value: topic.score_tag });
    //       });
    //       var scoreTags=[];
    //       scoreTagunique.forEach((score) => {
    //         if (score.star_rating !== false)
    //           scoreTags.push({
    //             name: score.score_tag,
    //             value: score.score_tag,
    //           });
    //       });
    //       this.starRatings = starRating;
    //       this.scoreTags = scoreTags;

    //       // this.getuniqueRatings(starRatingssorted);
    //       //  console.log("======================>", starRating)
    //       this.isLoading = false;
    //       return;
    //     });
    // },

    async getscoretagcommentCount() {
      var scoretagcommentCount = []; //store.getters.getdatastudioSentimentTP;
      this.isLoading = true;
      var partner_ids = [];
      var create_date = [];
      var location_ids = [];
      //  console.log("this.range :::: ", this.range);
      if (this.range !== null && this.range.length > 0) {
        if (this.range[0] !== null) {
          var start = moment(this.range[0]).format("YYYY-MM-DD");
          var end = moment(this.range[1]).format("YYYY-MM-DD");
          create_date.push(start);
          create_date.push(end);
        }
      }

      if (this.locationSelected.length > 0) {
        if (
          this.locationSelected.length === this.partner_ids.length &&
          this.locationSelected[0] === this.partner_ids[0]
        ) {
          partner_ids = this.partner_ids;
        } else {
          //  console.log("check businessunit and partner id length not same");
          partner_ids = this.partner_ids;
          location_ids = this.locationSelected;
        }
      } else {
        partner_ids = this.partner_ids;
      }

      var starRatings = [];
      if (this.starratingSelectedValue.length > 0) {
        starRatings = this.starratingSelectedValue;
      }
      var scoreTags = [];
      if (this.scoretagSelected.length > 0) {
        this.scoretagSelected.forEach((score_tag) => {
          scoreTags.push(score_tag.name);
        });
      }
      var topics = [];
      if (this.topicSelected.length > 0) {
        this.topicSelected.forEach((topic) => {
          topics.push(topic.category_name);
        });
      }

      //  console.log("this.starratingSelected.length ", topics);
      var business_unit_ids = [];
      var payload = {
        partner_ids: partner_ids,
        business_unit_ids: business_unit_ids,
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
        scoreTags: scoreTags,
        topics: topics,
        page_ref: "location",
      };
      this.loader_scoretagcommentCount = true;

      await store.dispatch("getscoretagcommentCount", payload).then(() => {
        scoretagcommentCount = store.getters.getscoreTagCommentCount;
        // var insights_sorted = _.sortBy(insights, "business_unit_id.name");
        //  console.log("scoretagcommentCount@@@@ ::::::::: ",  scoretagcommentCount);
        // this.scoretagcommentCount = scoretagcommentCount;
        // this.scoretagcommentCountArray = scoretagcommentCount;

        // this.getComment_count(scoretagcommentCount);
        this.getComment_scoretagcount(scoretagcommentCount);
        this.isLoading = false;
        this.loader_scoretagcommentCount = false;

        return;
      });
    },
    async getsentimentanalysisCount() {
      var sentimentanalysisCount = []; //store.getters.getdatastudioSentimentTP;

      this.isLoading = true;
      var partner_ids = [];
      var create_date = [];
      var location_ids = [];
      //  console.log("this.range :::: ", this.range);
      if (this.range !== null && this.range.length > 0) {
        if (this.range[0] !== null) {
          var start = moment(this.range[0]).format("YYYY-MM-DD");
          var end = moment(this.range[1]).format("YYYY-MM-DD");
          create_date.push(start);
          create_date.push(end);
        }
      }

      if (this.locationSelected.length > 0) {
        if (
          this.locationSelected.length === this.partner_ids.length &&
          this.locationSelected[0] === this.partner_ids[0]
        ) {
          partner_ids = this.partner_ids;
        } else {
          //  console.log("check businessunit and partner id length not same");
          partner_ids = this.partner_ids;
          location_ids = this.locationSelected;
        }
      } else {
        partner_ids = this.partner_ids;
      }

      var starRatings = [];
      if (this.starratingSelectedValue.length > 0) {
        starRatings = this.starratingSelectedValue;
      }
      var scoreTags = [];
      if (this.scoretagSelected.length > 0) {
        this.scoretagSelected.forEach((score_tag) => {
          scoreTags.push(score_tag.name);
        });
      }
      var topics = [];
      if (this.topicSelected.length > 0) {
        this.topicSelected.forEach((topic) => {
          topics.push(topic.category_name);
        });
      }

      //  console.log("this.starratingSelected.length ", topics);
      var business_unit_ids = [];
      var payload = {
        partner_ids: partner_ids,
        business_unit_ids: business_unit_ids,
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
        scoreTags: scoreTags,
        topics: topics,
        page_ref: "location",
      };
      this.loader_donutDatasets = true;
      await store.dispatch("getsentimentanalysisCount", payload).then(() => {
        sentimentanalysisCount = store.getters.getsentimentanalysisCount;
        this.score_data = sentimentanalysisCount;
        this.score_dataArray = sentimentanalysisCount;

        // this.getComment_count(scoretagcommentCount);
        // this.getComment_scoretagcount(scoretagcommentCount);
        this.isLoading = false;
        this.loader_donutDatasets = false;
        return;
      });
    },
    async getstarRatingandCommentData() {
      var starRatingandCommentData = [];

      this.isLoadingdata = true;
      var partner_ids = [];
      var create_date = [];
      var location_ids = [];
      //  console.log("this.range :::: ", this.range);
      if (this.range !== null && this.range.length > 0) {
        if (this.range[0] !== null) {
          var start = moment(this.range[0]).format("YYYY-MM-DD");
          var end = moment(this.range[1]).format("YYYY-MM-DD");
          create_date.push(start);
          create_date.push(end);
        }
      }

      if (this.locationSelected.length > 0) {
        if (
          this.locationSelected.length === this.partner_ids.length &&
          this.locationSelected[0] === this.partner_ids[0]
        ) {
          partner_ids = this.partner_ids;
        } else {
          //  console.log("check businessunit and partner id length not same");
          partner_ids = this.partner_ids;
          location_ids = this.locationSelected;
        }
      } else {
        partner_ids = this.partner_ids;
      }

      var starRatings = [];
      if (this.starratingSelectedValue.length > 0) {
        starRatings = this.starratingSelectedValue;
      }
      var scoreTags = [];
      if (this.scoretagSelected.length > 0) {
        this.scoretagSelected.forEach((score_tag) => {
          scoreTags.push(score_tag.name);
        });
      }
      var topics = [];
      if (this.topicSelected.length > 0) {
        this.topicSelected.forEach((topic) => {
          topics.push(topic.category_name);
        });
      }

      //  console.log("this.starratingSelected.length ", topics);
      var business_unit_ids = [];
      var payload = {
        partner_ids: partner_ids,
        business_unit_ids: business_unit_ids,
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
        scoreTags: scoreTags,
        topics: topics,
        page_ref: "location",
        offset: this.offset_insight,
      };
      this.loader_insights = true;
      await store.dispatch("getstarRatingandCommentData", payload).then(() => {
        starRatingandCommentData = store.getters.getstarRatingandCommentData;
        // this.insights = this.insightArray;
        // console.log("this.offset_insight ",  this.offset_insight, starRatingandCommentData)
        // var commentdata = starRatingandCommentData
        if (starRatingandCommentData.length > 0) {
          if (starRatingandCommentData.length > 0) {
            this.insights = [
              ...this.insights,
              ...starRatingandCommentData,
            ];
            this.insightsArray = [
              ...this.insightsArray,
              ...starRatingandCommentData,
            ];
            // console.log("starRatingandCommentData ::: ", this.insights, ...starRatingandCommentData);

            // this.insights = starRatingandCommentData;
            // this.insightArray = starRatingandCommentData;

            this.offset_insight += starRatingandCommentData.length;
            var aa = starRatingandCommentData.length - this.offset_insight;
            // console.log("this.offset_location", aa, this.offset_insight, starRatingandCommentData.length)
            if (aa == 0) {
              this.loadMore = false;
            } else {
              this.loadMore = true;
            }
          }
        } else {
          this.insights = [];
          this.insightsArray = [];
        }
        this.isLoadingdata = false;
        this.loader_insights = false;
        return;
      });
    },
    async getscoretagratingovertime() {
      var scoretagratingovertime = [];
      this.isLoading = true;
      var partner_ids = [];
      var create_date = [];
      var location_ids = [];
      //  console.log("this.range :::: ", this.range);
      if (this.range !== null && this.range.length > 0) {
        if (this.range[0] !== null) {
          var start = moment(this.range[0]).format("YYYY-MM-DD");
          var end = moment(this.range[1]).format("YYYY-MM-DD");
          create_date.push(start);
          create_date.push(end);
        }
      }

      if (this.locationSelected.length > 0) {
        if (
          this.locationSelected.length === this.partner_ids.length &&
          this.locationSelected[0] === this.partner_ids[0]
        ) {
          partner_ids = this.partner_ids;
        } else {
          //  console.log("check businessunit and partner id length not same");
          partner_ids = this.partner_ids;
          location_ids = this.locationSelected;
        }
      } else {
        partner_ids = this.partner_ids;
      }

      var starRatings = [];
      if (this.starratingSelectedValue.length > 0) {
        starRatings = this.starratingSelectedValue;
      }
      var scoreTags = [];
      if (this.scoretagSelected.length > 0) {
        this.scoretagSelected.forEach((score_tag) => {
          scoreTags.push(score_tag.name);
        });
      }
      var topics = [];
      if (this.topicSelected.length > 0) {
        this.topicSelected.forEach((topic) => {
          topics.push(topic.category_name);
        });
      }

      //  console.log("this.starratingSelected.length ", topics);
      var business_unit_ids = [];
      var payload = {
        partner_ids: partner_ids,
        business_unit_ids: business_unit_ids,
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
        scoreTags: scoreTags,
        topics: topics,
        page_ref: "location",
      };
      this.loader_barchart = true;
      await store.dispatch("getscoretagratingovertime", payload).then(() => {
        scoretagratingovertime = store.getters.getscoretagratingovertime;
        // console.log("store.getters.getscoretagratingovertime  :: ", store.getters.getscoretagratingovertime);
        var scoretagratingovertime_sorted = _.sortBy(
          scoretagratingovertime,
          "scoretagratingovertime_sorted.score_tags"
        );
        // console.log(
        //   "scoretagratingovertime_sorted 1111111:::: ",
        //   scoretagratingovertime_sorted
        // );
        this.getscoretagratingovertime1(scoretagratingovertime_sorted);
        // this.isLoading = false;
        this.loader_barchart = false;
        return;
      });
    },
    async getcategoryratingovertime() {
      var categoryratingovertime = [];
      this.isLoading = true;
      var partner_ids = [];
      var create_date = [];
      var location_ids = [];
      //  console.log("this.range :::: ", this.range);
      if (this.range !== null && this.range.length > 0) {
        if (this.range[0] !== null) {
          var start = moment(this.range[0]).format("YYYY-MM-DD");
          var end = moment(this.range[1]).format("YYYY-MM-DD");
          create_date.push(start);
          create_date.push(end);
        }
      }

      if (this.locationSelected.length > 0) {
        if (
          this.locationSelected.length === this.partner_ids.length &&
          this.locationSelected[0] === this.partner_ids[0]
        ) {
          partner_ids = this.partner_ids;
        } else {
          //  console.log("check businessunit and partner id length not same");
          partner_ids = this.partner_ids;
          location_ids = this.locationSelected;
        }
      }

      if (this.partner_ids.length > 0) {
        partner_ids = this.partner_ids;
      }

      var starRatings = [];
      if (this.starratingSelectedValue.length > 0) {
        starRatings = this.starratingSelectedValue;
      }
      var scoreTags = [];
      if (this.scoretagSelected.length > 0) {
        this.scoretagSelected.forEach((score_tag) => {
          scoreTags.push(score_tag.name);
        });
      }
      var topics = [];
      if (this.topicSelected.length > 0) {
        this.topicSelected.forEach((topic) => {
          topics.push(topic.category_name);
        });
      }

      //  console.log("this.starratingSelected.length ", topics);
      var business_unit_ids = [];
      var payload = {
        partner_ids: partner_ids,
        business_unit_ids: business_unit_ids,
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
        scoreTags: scoreTags,
        topics: topics,
        page_ref: "location",
      };
      await store.dispatch("getcategoryratingovertime", payload).then(() => {
        categoryratingovertime = store.getters.getcategoryratingovertime;
        // console.log(
        //   "store.getters.categoryratingovertime  :: ",
        //   categoryratingovertime
        // );
        var categoryratingovertime_sorted = _.sortBy(
          categoryratingovertime,
          "categoryratingovertime.category_id"
        );
        // console.log(
        //   "categoryratingovertime_sorted",
        //   categoryratingovertime_sorted
        // );
        if (categoryratingovertime_sorted.length > 0) {
          this.getscoretagratingovertime2(categoryratingovertime_sorted);
        } else {
          this.apexdata_label = [];
          this.dataset_apexchart = [];
          this.categories = [];

          this.apex_dataconfig_data = {
            dataSource: {
              type: "bar",
              chartOptions: {
                chart: {
                  type: "bar",
                  height: 300,
                  stacked: true,
                  toolbar: {
                    show: true,
                  },
                  zoom: {
                    enabled: true,
                  },
                },
              },
            },
          };
          this.apex_f_dataconfig_data = {
            dataSource: {
              type: "bar",
              chartOptions: {
                chart: {
                  type: "bar",
                  height: 300,
                  stacked: true,
                  toolbar: {
                    show: true,
                  },
                  zoom: {
                    enabled: true,
                  },
                },
              },
            },
          };
        }
        this.isLoading = false;
        return;
      });
    },
    async gettopicstarratingCount() {
      var topic_starratingcount = [];
      this.isLoading = true;
      var partner_ids = [];
      var create_date = [];
      var location_ids = [];
      //  console.log("this.range :::: ", this.range);
      if (this.range !== null && this.range.length > 0) {
        if (this.range[0] !== null) {
          var start = moment(this.range[0]).format("YYYY-MM-DD");
          var end = moment(this.range[1]).format("YYYY-MM-DD");
          create_date.push(start);
          create_date.push(end);
        }
      }

      if (this.locationSelected.length > 0) {
        if (
          this.locationSelected.length === this.partner_ids.length &&
          this.locationSelected[0] === this.partner_ids[0]
        ) {
          partner_ids = this.partner_ids;
        } else {
          //  console.log("check businessunit and partner id length not same");
          partner_ids = this.partner_ids;
          location_ids = this.locationSelected;
        }
      } else {
        partner_ids = this.partner_ids;
      }

      var starRatings = [];
      if (this.starratingSelectedValue.length > 0) {
        starRatings = this.starratingSelectedValue;
      }
      var scoreTags = [];
      if (this.scoretagSelected.length > 0) {
        this.scoretagSelected.forEach((score_tag) => {
          scoreTags.push(score_tag.name);
        });
      }
      var topics = [];
      if (this.topicSelected.length > 0) {
        this.topicSelected.forEach((topic) => {
          topics.push(topic.category_name);
        });
      }

      //  console.log("this.starratingSelected.length ", topics);
      var business_unit_ids = [];
      var payload = {
        partner_ids: partner_ids,
        business_unit_ids: business_unit_ids,
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
        scoreTags: scoreTags,
        topics: topics,
        page_ref: "location",
      };
      this.loader_piechartDatasets = true;
      await store.dispatch("gettopicstarratingCount", payload).then(() => {
        topic_starratingcount = store.getters.gettopicstarratingCount;
        //  console.log("store.getters.gettopicstarratingCount  :: ", topic_starratingcount);
        var topic_starratingcount1 = _.sortBy(
          topic_starratingcount,
          "category_id[1]"
        );
        this.gettopic_starratingcount(topic_starratingcount1);
        this.isLoading = false;
        this.loader_piechartDatasets = false;
        return;
      });
    },
    async gettopicavgstarratingCount() {
      var topicavgstarratingCount = [];
      this.isLoading = true;
      var partner_ids = [];
      var create_date = [];
      var location_ids = [];
      //  console.log("this.range :::: ", this.range);
      if (this.range !== null && this.range.length > 0) {
        if (this.range[0] !== null) {
          var start = moment(this.range[0]).format("YYYY-MM-DD");
          var end = moment(this.range[1]).format("YYYY-MM-DD");
          create_date.push(start);
          create_date.push(end);
        }
      }

      if (this.locationSelected.length > 0) {
        if (
          this.locationSelected.length === this.partner_ids.length &&
          this.locationSelected[0] === this.partner_ids[0]
        ) {
          partner_ids = this.partner_ids;
        } else {
          //  console.log("check businessunit and partner id length not same");
          partner_ids = this.partner_ids;
          location_ids = this.locationSelected;
        }
      } else {
        partner_ids = this.partner_ids;
      }

      var starRatings = [];
      if (this.starratingSelectedValue.length > 0) {
        starRatings = this.starratingSelectedValue;
      }
      var scoreTags = [];
      if (this.scoretagSelected.length > 0) {
        this.scoretagSelected.forEach((score_tag) => {
          scoreTags.push(score_tag.name);
        });
      }
      var topics = [];
      if (this.topicSelected.length > 0) {
        this.topicSelected.forEach((topic) => {
          topics.push(topic.category_name);
        });
      }

      //  console.log("this.starratingSelected.length ", topics);
      var business_unit_ids = [];
      var payload = {
        partner_ids: partner_ids,
        business_unit_ids: business_unit_ids,
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
        scoreTags: scoreTags,
        topics: topics,
        page_ref: "location",
      };
      this.loader_barchartDatasets1 = true;
      await store.dispatch("gettopicavgstarratingCount", payload).then(() => {
        topicavgstarratingCount = store.getters.gettopicavgstarratingCount;
        //  console.log("store.getters.gettopicavgstarratingCount  :: ", topicavgstarratingCount);

        // this.gettopic_starratingcount1(topicavgstarratingCount);
        // this.getscoretagratingovertime_category(topicavgstarratingCount);
        if (topicavgstarratingCount) {
          this.gettopic_starratingcount1(topicavgstarratingCount);
          this.getscoretagratingovertime_category(topicavgstarratingCount);
        } else {
          this.topic_avg_starrating_data = [];
          this.apexdata_radar_label = [];
          this.apex_dataconfig_data_radar = {
            dataSource: {
              type: "radar",
              chartOptions: {
                chart: {
                  type: "radar",
                  height: 300,
                },
              },
            },
          };
        }

        this.isLoading = false;
        this.loader_barchartDatasets1 = false;
        return;
      });
    },
    async getformdataCount() {
      var formdataCount = [];
      this.isLoading = true;
      var partner_ids = [];
      var create_date = [];
      var location_ids = [];
      //  console.log("this.range :::: ", this.range);
      if (this.range !== null && this.range.length > 0) {
        if (this.range[0] !== null) {
          var start = moment(this.range[0]).format("YYYY-MM-DD");
          var end = moment(this.range[1]).format("YYYY-MM-DD");
          create_date.push(start);
          create_date.push(end);
        }
      }

      if (this.locationSelected.length > 0) {
        if (
          this.locationSelected.length === this.partner_ids.length &&
          this.locationSelected[0] === this.partner_ids[0]
        ) {
          partner_ids = this.partner_ids;
        } else {
          //  console.log("check businessunit and partner id length not same");
          partner_ids = this.partner_ids;
          location_ids = this.locationSelected;
        }
      } else {
        partner_ids = this.partner_ids;
      }

      var starRatings = [];
      if (this.starratingSelectedValue.length > 0) {
        starRatings = this.starratingSelectedValue;
      }
      var scoreTags = [];
      if (this.scoretagSelected.length > 0) {
        this.scoretagSelected.forEach((score_tag) => {
          scoreTags.push(score_tag.name);
        });
      }
      var topics = [];
      if (this.topicSelected.length > 0) {
        this.topicSelected.forEach((topic) => {
          topics.push(topic.category_name);
        });
      }

      //  console.log("this.starratingSelected.length ", topics);
      var business_unit_ids = [];
      var payload = {
        partner_ids: partner_ids,
        business_unit_ids: business_unit_ids,
        location_ids: location_ids,
        starRatings: starRatings,
        create_date: create_date,
        scoreTags: scoreTags,
        topics: topics,
        page_ref: "location",
      };
      this.loader_barchartDatasets2 = true;
      await store.dispatch("getformdataCount", payload).then(() => {
        formdataCount = store.getters.getformdataCount;
        //  console.log("store.getters.getformdataCountCount  :: ", formdataCount);
        // console.log("info-", "formdataCount", formdataCount);

        // this.topic_form_data = formdataCount;
        this.form_count_data = formdataCount;
        var topics = [];
        formdataCount.forEach((topic) => {
          topics.push({ category_name: topic.Form });
        });
        this.getuniqueTopics(topics);
        // this.gettopic_formcount(formdataCount);
        // this.getscoretagratingovertime_category(topicavgstarratingCount);
        this.isLoading = false;
        this.loader_barchartDatasets2 = false;
        return;
      });
    },

    getscoretagratingovertime1(insights_sorted) {
      // console.log("info-", "1111111 ", insights_sorted);
      var count = 0;
      var prev_key = "";
      // var starRatings=[];
      var scoreTags = [];
      insights_sorted.forEach((insight) => {
        // //console.log("insights in getscoretagratingovertime1 ::::::::: ",insight);

        // if(insight.star_rating !==false)
        //   starRatings.push({"name":topic.star_rating, "value":topic.star_rating});
        if (insight.score_tag !== false)
          scoreTags.push({ name: insight.score_tag, value: insight.score_tag });
      });
      //console.log("starRatings :::", starRatings);
      // this.getuniqueRatings(starRatings);
      this.getuniquescoreTags(scoreTags);
      // this.getscoretagratingovertime1(insights_sorted);

      // var endDate = moment().endOf("month").format("DD MMM YYYY");
      // var startDate = moment()
      //   .subtract(1, "year")
      //   .add(1, "month")
      //   .startOf("month")
      //   .format("DD MMM YYYY");
      //console.log("startDate======", startDate);
      //console.log("endDate======111", endDate);
      var months = [];
      // var currentDate = startDate;
      // while (moment(currentDate) < moment(endDate)) {
      //   months.push(moment(currentDate).format("MMM YYYY"));
      //   currentDate = moment(currentDate).add(1, "month").format("DD MMM YYYY");
      // }

      // var insights_sorted1 = _.sortBy(insights_sorted, "create_time");
      // var filtered_data = insights_sorted.filter((item) => {
      //   return (
      //     moment(item.create_time) >= moment(startDate) &&
      //     moment(item.create_time) < moment(endDate)
      //   );
      // });
      const result_monthdata = [
        ...insights_sorted
          .reduce((r, o) => {
            const key = o["createTime:month"] + "-" + o.score_tag;
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                count: 0,
                month: "",
              });
            // //console.log("key in score::::::::", key);
            // if(o.score_tag !== false){
            if (prev_key !== key) {
              item.count += o.__count;
              prev_key = key;
              item.month = o["createTime:month"];
              months.push(o["createTime:month"]);
            } else item.count += o.__count;
            // }

            //  console.log("key, item", key, item, item.month)

            return r.set(key, item);
          }, new Map())
          .values(),
      ];
      // this.barchartscoredata=result_monthdata;
      // this.barchartscoredata_label = [...new Set(this.barchartscoredata_label)] ;
      this.barchartscoredata_label = [...new Set(months)];
      this.barchartDatacollection.labels = [...new Set(months)];

      this.barchartdata(result_monthdata);
      // console.log("Info-", "result_monthdata::: ", months, result_monthdata);
    },

    getscoretagratingovertime2(insights_sorted) {
      var count = 0;
      var prev_key = "";
      // var starRatings=[];
      var categories = [];

      var insights_sorted1 = _.sortBy(
        insights_sorted,
        "insights_sorted.category_id[1]"
      );
      insights_sorted1.forEach((insight) => {
        //  console.log("insight", insight);
        if (insight.category_id !== false)
          categories.push(insight.category_id[1]);
        //  console.log("Insight category_name", insight.category_id);
      });
      // //console.log("starRatings :::", starRatings);
      // this.getuniqueRatings(starRatings);
      this.getuniqueCategories(categories);
      // this.getscoretagratingovertime1(insights_sorted);

      // var endDate =
      //   typeof this.range !== "string" && this.range[1] !== null
      //     ? moment(this.range[1]).format("DD MMM YYYY")
      //     : moment().endOf("month").format("DD MMM YYYY");
      // var startDate =
      //   typeof this.range !== "string" && this.range[0] !== null
      //     ? moment(this.range[0]).format("DD MMM YYYY")
      //     : moment()
      //         .subtract(1, "year")
      //         .add(1, "month")
      //         .startOf("month")
      //         .format("DD MMM YYYY");
      //console.log("startDate======12211", startDate ,(typeof(this.range) !== "string" && this.range[0]!==null ));
      //console.log("endDate======12211", endDate, (typeof(this.range) !== "string"|| this.range[0]!==null));
      var months = [];
      // var currentDate = startDate;
      // while (moment(currentDate) < moment(endDate)) {
      //   months.push(moment(currentDate).format("MMM YYYY"));
      //   currentDate = moment(currentDate).add(1, "month").format("DD MMM YYYY");
      // }

      // var insights_sorted1 = _.sortBy(insights_sorted, "create_time");
      // var filtered_data = insights_sorted1.filter((item) => {
      //   return (
      //     moment(item.create_time) >= moment(startDate) &&
      //     moment(item.create_time) < moment(endDate)
      //   );
      // });
      // //console.log("filtered_data", filtered_data);
      const result_monthdata = [
        ...insights_sorted
          .reduce((r, o) => {
            const key = o["review_create_time:month"] + "-" + o.category_id[1];
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                count: 0,
                month: "",
              });
            // //console.log("key in score::::::::", key);
            if (prev_key !== key) {
              item.count += o.__count;

              prev_key = key;
              item.month = o["review_create_time:month"];
              if (!months.includes(o["review_create_time:month"]))
                months.push(o["review_create_time:month"]);
            } else {
              item.count += o.__count;
              // item.sum_avg_star_rating += o.avg_star_rating;
            }
            // //console.log("key, item", key, item, item.month)

            return r.set(key, item);
          }, new Map())
          .values(),
      ];
      // this.barchartscoredata=result_monthdata;

      this.apexdata_label = months;
      // this.apexdata_radar_label = months;

      this.getapexData(result_monthdata);
      // this.getapexradarData(result_monthdata);
      // console.log(
      //   "result_monthdata apex $$$$$$$$$$$$$",
      //   months,
      //   result_monthdata
      // );
    },
    getscoretagratingovertime_category(insights_sorted) {
      var count = 0;
      var prev_key = "";
      // var starRatings=[];
      var categories = [];
      var topics = [];
      insights_sorted.forEach((insight) => {
        if (insight.category_id !== false)
          categories.push(insight.category_id[1]);
        // categories.push({ category_name: insight.category_id[1]});
        topics.push({ category_name: insight.category_id[1] });
      });
      // //console.log("starRatings :::", starRatings);
      // this.getuniqueRatings(starRatings);
      this.getuniqueCategories(categories);
      // this.getuniqueTopics(topics);
      // this.getscoretagratingovertime1(insights_sorted);

      // var endDate =
      //   typeof this.range !== "string" && this.range[1] !== null
      //     ? moment(this.range[1]).format("DD MMM YYYY")
      //     : moment().endOf("month").format("DD MMM YYYY");
      // var startDate =
      //   typeof this.range !== "string" && this.range[0] !== null
      //     ? moment(this.range[0]).format("DD MMM YYYY")
      //     : moment()
      //         .subtract(1, "year")
      //         .add(1, "month")
      //         .startOf("month")
      //         .format("DD MMM YYYY");

      //console.log("startDate======12211", startDate ,(typeof(this.range) !== "string" && this.range[0]!==null ));
      //console.log("endDate======12211", endDate, (typeof(this.range) !== "string"|| this.range[0]!==null));
      var months = [];
      // var currentDate = startDate;
      // while (moment(currentDate) < moment(endDate)) {
      //   months.push(moment(currentDate).format("MMM YYYY"));
      //   currentDate = moment(currentDate).add(1, "month").format("DD MMM YYYY");
      // }

      // var insights_sorted1 = _.sortBy(insights_sorted, "create_time");
      // var filtered_data = insights_sorted1.filter((item) => {
      //   return (
      //     moment(item.create_time) >= moment(startDate) &&
      //     moment(item.create_time) < moment(endDate)
      //   );
      // });
      // //console.log("filtered_data", filtered_data);
      const result_monthdata = [
        ...insights_sorted
          .reduce((r, o) => {
            // const key = o.category_id[1];
            const key = o.category_id[1];
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                count: 0,
                sum_avg_star_rating: 0,
                month: "",
              });
            // //console.log("key in score::::::::", key);
            if (prev_key !== key) {
              item.count += 1;
              // item.sum_avg_star_rating += o.avg_star_rating;
              prev_key = key;
            } else {
              item.count += 1;
            }
            // console.log("key, item", key, item)

            return r.set(key, item);
          }, new Map())
          .values(),
      ];
      // this.barchartscoredata=result_monthdata;
      // this.apexdata_label = months;
      this.apexdata_radar_label = this.categories;

      // this.getapexData(result_monthdata);
      this.getapexradarData(result_monthdata);
      // console.log("result_monthdata radar  apex 2901 1122$$$$$$$$$$$$$",months,result_monthdata, this.apex_data);
    },
    gettopic_starratingcount(topic) {
      var count = 0;
      var prev_key = "";
      const result_star_rating = [
        ...topic
          .reduce((r, o) => {
            const key = o.category_id[1];
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                count: 0,
                // instances: 0
              });
            //  console.log("key in score::::::::", key);
            // if(key !== false){
            if (prev_key !== key) {
              item.count += o.__count;
              prev_key = key;
            } else item.count += o.__count;
            // }

            return r.set(key, item);
          }, new Map())
          .values(),
      ];

      this.topic_starrating_data = result_star_rating;
      // var result_star_rating1 = [];
      // result_star_rating.forEach((rating) => {
      //   // if (rating.category_id[1] !== false)
      //     result_star_rating1.push(rating);
      // });
      // this.topic_starrating_data = result_star_rating1;

      // //console.log("this.topic_starrating_data", this.topic_starrating_data);
    },

    gettopic_starratingcount1(topic) {
      // //console.log("key in gettopic_starratingcount1:::::::: topic", topic);
      var count = 0;
      var avg_star_rating = 0;
      var sum_avg_star_rating = 0;
      var star_rating = 0;
      var prev_key = "";
      var total_avg_star_rating = [];
      const result_star_rating = [
        ...topic
          .reduce((r, o) => {
            const key = o.category_id[1];
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                count: 0,
                sum_avg_star_rating: 0,
                total_avg_star_rating: 0,
                month: "",
              });
            // //console.log("key in gettopic_starratingcount1::::::::", o.avg_star_rating);
            if (prev_key !== key) {
              item.count += o.__count;
              // item.sum_avg_star_rating += o.avg_star_rating;
              prev_key = key;
              // item.month = o.create_time).format("MMM YYYY");
            } else {
              item.count += o.__count;
              // item.sum_avg_star_rating += o.avg_star_rating;
            }

            // //console.log("key, item", item.sum_avg_star_rating);
            return r.set(key, item);
          }, new Map())
          .values(),
      ];
      // //console.log("item  chart", item.category_name, total_avg_star_rating);
      var result_star_rating1 = [];
      // result_star_rating.forEach((rating) => {
      //   if (rating.category_name !== false) {
      //     var total = rating.sum_avg_star_rating / rating.count;
      //     rating.sum_avg_star_rating = parseFloat(total).toFixed(1);
      //     result_star_rating1.push(rating);
      //   }
      // });
      //  console.log("result_star_rating ::: ", result_star_rating);
      this.topic_avg_starrating_data = result_star_rating;
      //  console.log("result_star_rating 3137 ::: ", result_star_rating);
    },

    getComment_scoretagcount(insights_sorted) {
      var count = 0;
      var prev_key = "";
      const result_score_tag = [
        ...insights_sorted
          .reduce((r, o) => {
            const key = o.location_id[1] + "-" + o.score_tag;
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                count: 0,
                location_label: "",
                // instances: 0
              });
            if (key !== "false") {
              if (prev_key !== key) {
                item.count += o.score_tag !== "false" ? o.__count : 0;
                item.location_label = o.location_id[1];
                prev_key = key;
                // console.log("key in score::::::::", key, item.count);
              } else item.count += o.score_tag !== "false" ? o.__count : 0;
            } else {
              //console.log("no match false", key);
            }

            return r.set(key, item);
          }, new Map())
          .values(),
      ];
      // var scoretags = [];
      // result_score_tag.forEach((item) => {
      //   if (item.score_tag !== false)
      //     scoretags.push(item);
      // });
      // var result_score_tag = result_score_tag.filter((item) => {
      //     return result_score_tag.score_tag !== false
      //   });
      // this.score_data = scoretags;
      // this.score_dataArray = scoretags;
      //  console.log("result_score_tag ::: ", result_score_tag);
      this.scoretagcommentCount = result_score_tag;
      this.scoretagcommentCountArray = result_score_tag;

      // console.log("this.score_data", this.score_data);
    },

    /********/
    // getscoretagratingovertime1(insights_sorted) {
    //   var count = 0;
    //   var prev_key = "";
    //   // var starRatings=[];
    //   var scoreTags = [];
    //   insights_sorted.forEach((insight) => {
    //     // //console.log("insights in getscoretagratingovertime1 ::::::::: ",insight);

    //     // if(insight.star_rating !==false)
    //     //   starRatings.push({"name":topic.star_rating, "value":topic.star_rating});
    //     if (insight.score_tag !== false)
    //       scoreTags.push({ name: insight.score_tag, value: insight.score_tag });
    //   });
    //   // //console.log("starRatings :::", starRatings);
    //   // this.getuniqueRatings(starRatings);
    //   this.getuniquescoreTags(scoreTags);
    //   // this.getscoretagratingovertime1(insights_sorted);

    //   var endDate = moment().endOf("month").format("DD MMM YYYY");
    //   var startDate = moment()
    //     .subtract(1, "year")
    //     .add(1, "month")
    //     .startOf("month")
    //     .format("DD MMM YYYY");
    //   //console.log("startDate======", startDate);
    //   //console.log("endDate======111", endDate);
    //   var months = [];
    //   var currentDate = startDate;
    //   while (moment(currentDate) < moment(endDate)) {
    //     months.push(moment(currentDate).format("MMM YYYY"));
    //     currentDate = moment(currentDate).add(1, "month").format("DD MMM YYYY");
    //   }

    //   var insights_sorted1 = _.sortBy(insights_sorted, "create_time");
    //   var filtered_data = insights_sorted1.filter((item) => {
    //     return (
    //       moment(item.create_time) >= moment(startDate) &&
    //       moment(item.create_time) < moment(endDate)
    //     );
    //   });
    //   const result_monthdata = [
    //     ...filtered_data
    //       .reduce((r, o) => {
    //         const key =
    //           moment(o.create_time).format("MMM YYYY") + "-" + o.score_tag;
    //         const item =
    //           r.get(key) ||
    //           Object.assign({}, o, {
    //             count: 0,
    //             month: "",
    //           });
    //         // //console.log("key in score::::::::", key);
    //         if (prev_key !== key) {
    //           item.count += 1;
    //           prev_key = key;
    //           item.month = moment(o.create_time).format("MMM YYYY");
    //         } else item.count += 1;

    //         // //console.log("key, item", key, item, item.month)

    //         return r.set(key, item);
    //       }, new Map())
    //       .values(),
    //   ];
    //   // this.barchartscoredata=result_monthdata;
    //   this.barchartscoredata_label = months;
    //   this.barchartDatacollection.label = months;

    //   this.barchartdata(result_monthdata);
    //   // //console.log("result_monthdata",months,result_monthdata);
    // },

    // getscoretagratingovertime2(insights_sorted) {
    //   var count = 0;
    //   var prev_key = "";
    //   // var starRatings=[];
    //   var categories = [];
    //   insights_sorted.forEach((insight) => {
    //     if (insight.category_name !== false)
    //       categories.push(insight.category_name);
    //   //  console.log("Insight category_name", insight.category_name);
    //   });
    //   // //console.log("starRatings :::", starRatings);
    //   // this.getuniqueRatings(starRatings);
    //   this.getuniqueCategories(categories);
    //   // this.getscoretagratingovertime1(insights_sorted);

    //   var endDate =
    //     typeof this.range !== "string" && this.range[1] !== null
    //       ? moment(this.range[1]).format("DD MMM YYYY")
    //       : moment().endOf("month").format("DD MMM YYYY");
    //   var startDate =
    //     typeof this.range !== "string" && this.range[0] !== null
    //       ? moment(this.range[0]).format("DD MMM YYYY")
    //       : moment()
    //           .subtract(1, "year")
    //           .add(1, "month")
    //           .startOf("month")
    //           .format("DD MMM YYYY");
    //   //console.log("startDate======12211", startDate ,(typeof(this.range) !== "string" && this.range[0]!==null ));
    //   //console.log("endDate======12211", endDate, (typeof(this.range) !== "string"|| this.range[0]!==null));
    //   var months = [];
    //   var currentDate = startDate;
    //   while (moment(currentDate) < moment(endDate)) {
    //     months.push(moment(currentDate).format("MMM YYYY"));
    //     currentDate = moment(currentDate).add(1, "month").format("DD MMM YYYY");
    //   }

    //   var insights_sorted1 = _.sortBy(insights_sorted, "create_time");
    //   var filtered_data = insights_sorted1.filter((item) => {
    //     return (
    //       moment(item.create_time) >= moment(startDate) &&
    //       moment(item.create_time) < moment(endDate)
    //     );
    //   });
    //   // //console.log("filtered_data", filtered_data);
    //   const result_monthdata = [
    //     ...filtered_data
    //       .reduce((r, o) => {
    //         const key =
    //           moment(o.create_time).format("MMM YYYY") + "-" + o.category_name;
    //         const item =
    //           r.get(key) ||
    //           Object.assign({}, o, {
    //             count: 0,
    //             sum_avg_star_rating: 0,
    //             month: "",
    //           });
    //         // //console.log("key in score::::::::", key);
    //         if (prev_key !== key) {
    //           item.count += 1;
    //           item.sum_avg_star_rating += o.avg_star_rating;
    //           prev_key = key;
    //           item.month = moment(o.create_time).format("MMM YYYY");
    //         } else {
    //           item.count += 1;
    //           item.sum_avg_star_rating += o.avg_star_rating;
    //         }
    //         // //console.log("key, item", key, item, item.month)

    //         return r.set(key, item);
    //       }, new Map())
    //       .values(),
    //   ];
    //   // this.barchartscoredata=result_monthdata;
    //   this.apexdata_label = months;
    //   // this.apexdata_radar_label = months;

    //   this.getapexData(result_monthdata);
    //   // this.getapexradarData(result_monthdata);
    //   //  console.log("result_monthdata apex $$$$$$$$$$$$$",result_monthdata);
    // },
    // getscoretagratingovertime_category(insights_sorted) {
    //   var count = 0;
    //   var prev_key = "";
    //   // var starRatings=[];
    //   var categories = [];
    //   insights_sorted.forEach((insight) => {
    //     if (insight.category_name !== false)
    //       categories.push(insight.category_name);
    //   });
    //   // //console.log("starRatings :::", starRatings);
    //   // this.getuniqueRatings(starRatings);
    //   this.getuniqueCategories(categories);
    //   // this.getscoretagratingovertime1(insights_sorted);

    //   var endDate =
    //     typeof this.range !== "string" && this.range[1] !== null
    //       ? moment(this.range[1]).format("DD MMM YYYY")
    //       : moment().endOf("month").format("DD MMM YYYY");
    //   var startDate =
    //     typeof this.range !== "string" && this.range[0] !== null
    //       ? moment(this.range[0]).format("DD MMM YYYY")
    //       : moment()
    //           .subtract(1, "year")
    //           .add(1, "month")
    //           .startOf("month")
    //           .format("DD MMM YYYY");
    //   //console.log("startDate======12211", startDate ,(typeof(this.range) !== "string" && this.range[0]!==null ));
    //   //console.log("endDate======12211", endDate, (typeof(this.range) !== "string"|| this.range[0]!==null));
    //   var months = [];
    //   var currentDate = startDate;
    //   while (moment(currentDate) < moment(endDate)) {
    //     months.push(moment(currentDate).format("MMM YYYY"));
    //     currentDate = moment(currentDate).add(1, "month").format("DD MMM YYYY");
    //   }

    //   var insights_sorted1 = _.sortBy(insights_sorted, "create_time");
    //   var filtered_data = insights_sorted1.filter((item) => {
    //     return (
    //       moment(item.create_time) >= moment(startDate) &&
    //       moment(item.create_time) < moment(endDate)
    //     );
    //   });
    //   // //console.log("filtered_data", filtered_data);
    //   const result_monthdata = [
    //     ...filtered_data
    //       .reduce((r, o) => {
    //         const key = o.category_name;
    //         // const key =  moment(o.create_time).format('MMM YYYY') + '-' + o.category_name ;
    //         const item =
    //           r.get(key) ||
    //           Object.assign({}, o, {
    //             count: 0,
    //             sum_avg_star_rating: 0,
    //             month: "",
    //           });
    //         // //console.log("key in score::::::::", key);
    //         if (prev_key !== key) {
    //           item.count += 1;
    //           item.sum_avg_star_rating += o.avg_star_rating;
    //           prev_key = key;
    //           item.month = moment(o.create_time).format("MMM YYYY");
    //         } else {
    //           item.count += 1;
    //           item.sum_avg_star_rating += o.avg_star_rating;
    //         }
    //         // //console.log("key, item", key, item, item.month)

    //         return r.set(key, item);
    //       }, new Map())
    //       .values(),
    //   ];
    //   // this.barchartscoredata=result_monthdata;
    //   // this.apexdata_label = months;
    //   this.apexdata_radar_label = this.categories;

    //   // this.getapexData(result_monthdata);
    //   this.getapexradarData(result_monthdata);
    //   //console.log("result_monthdata apex $$$$$$$$$$$$$",months,result_monthdata, this.apex_data);
    // },
    // gettopic_starratingcount(topic) {
    //   var count = 0;
    //   var prev_key = "";
    //   const result_star_rating = [
    //     ...topic
    //       .reduce((r, o) => {
    //         const key = o.category_name;
    //         const item =
    //           r.get(key) ||
    //           Object.assign({}, o, {
    //             count: 0,
    //             // instances: 0
    //           });
    //         // //console.log("key in score::::::::", key);
    //         // if(key !== false){
    //         if (prev_key !== key) {
    //           item.count += 1;
    //           prev_key = key;
    //         } else item.count += 1;
    //         // }

    //         return r.set(key, item);
    //       }, new Map())
    //       .values(),
    //   ];

    //   // this.topic_starrating_data=result_star_rating;
    //   var result_star_rating1 = [];
    //   result_star_rating.forEach((rating) => {
    //     if (rating.category_name !== false) result_star_rating1.push(rating);
    //   });
    //   this.topic_starrating_data = result_star_rating1;

    //   // //console.log("this.topic_starrating_data", this.topic_starrating_data);
    // },

    // gettopic_starratingcount1(topic) {
    //   // //console.log("key in gettopic_starratingcount1:::::::: topic", topic);
    //   var count = 0;
    //   var avg_star_rating = 0;
    //   var sum_avg_star_rating = 0;
    //   var star_rating = 0;
    //   var prev_key = "";
    //   var total_avg_star_rating = [];
    //   const result_star_rating = [
    //     ...topic
    //       .reduce((r, o) => {
    //         const key = o.category_name;
    //         const item =
    //           r.get(key) ||
    //           Object.assign({}, o, {
    //             count: 0,
    //             sum_avg_star_rating: 0,
    //             total_avg_star_rating: 0,
    //             month: "",
    //           });
    //         // //console.log("key in gettopic_starratingcount1::::::::", o.avg_star_rating);
    //         if (prev_key !== key) {
    //           item.count += 1;
    //           item.sum_avg_star_rating += o.avg_star_rating;
    //           prev_key = key;
    //           item.month = moment(o.create_time).format("MMM YYYY");
    //         } else {
    //           item.count += 1;
    //           item.sum_avg_star_rating += o.avg_star_rating;
    //         }

    //         // //console.log("key, item", item.sum_avg_star_rating);
    //         return r.set(key, item);
    //       }, new Map())
    //       .values(),
    //   ];
    //   // //console.log("item  chart", item.category_name, total_avg_star_rating);
    //   var result_star_rating1 = [];
    //   result_star_rating.forEach((rating) => {
    //     if (rating.category_name !== false) {
    //       // //console.log(rating, rating.sum_avg_star_rating, rating.count ,rating.sum_avg_star_rating/ rating.count , "<=====rating.sum_avg_star_rating/ rating.count")
    //       var total = rating.sum_avg_star_rating / rating.count;
    //       rating.sum_avg_star_rating = parseFloat(total).toFixed(1);
    //       result_star_rating1.push(rating);
    //     }
    //   });
    //   this.topic_avg_starrating_data = result_star_rating1;
    //   // //console.log("result_star_rating ::: ", result_star_rating);
    // },

    // getformcount(form) {
    //   var count = 0;
    //   var prev_key = "";
    //   const result_form_count = [
    //     ...form
    //       .reduce((r, o) => {
    //         // if(o.count > 1 ){
    //         const key = o.form;
    //         const item =
    //           r.get(key) ||
    //           Object.assign({}, o, {
    //             count: 0,
    //             // instances: 0
    //           });
    //         // //console.log("key in score::::::::", key);
    //         if (key !== "false") {
    //           if (prev_key !== key) {
    //             item.count += 1;
    //             prev_key = key;
    //           } else item.count += 1;
    //         }
    //         // }else{
    //         //   //console.log("no match false", key);
    //         // }
    //         return r.set(key, item);
    //         // }
    //       }, new Map())
    //       .values(),
    //   ];

    //   var result_form_count1 = _.sortBy(result_form_count, "count").reverse();
    //   this.form_count_data = result_form_count1;
    //   //console.log("result_form_count ::::: ", result_form_count);
    // },

    gettopic_formcount(topic) {
      var count = 0;
      var prev_key = "";
      const result_star_rating = [
        ...topic
          .reduce((r, o) => {
            const key = o.topic_form;
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                count: 0,
                // instances: 0
              });
            // //console.log("key in score::::::::", key);
            if (key !== "false") {
              if (prev_key !== key) {
                item.count += 1;
                prev_key = key;
              } else item.count += 1;
            } else {
              //console.log("no match false", key);
            }

            return r.set(key, item);
          }, new Map())
          .values(),
      ];
      this.topic_form_data = result_star_rating;
      // //console.log("this.topic_form_data", this.topic_form_data);
    },
    getComment_count(insights_sorted) {
      var count = 0;
      var location_label = "";
      var prev_key = "";
      const result = [
        ...insights_sorted
          .reduce((r, o) => {
            // console.log("insight key::::::::", o);
            const key =
              o.location_name + "-" + o.location_id.city + "-" + o.score_tag;
            // console.log("insight key::::::::", key);
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                count: 0,
                location_label: "",
                // instances: 0
              });
            if (prev_key !== key) {
              item.count += 1;
              prev_key = key;
              item.location_label =
                o.location_name +
                " - " +
                o.location_id.city +
                " - " +
                o.location_id.description;
              // console.log("insight key::::::::", key, location_label);
            } else {
              item.count += 1;
            }
            return r.set(key, item);
          }, new Map())
          .values(),
      ];
      //  console.log("result11111111111::::", result);
      this.commentCount = result;
      this.commentCountArray = result;
    },
    getuniqueRatings(starRatings) {
      const starRatingunique = [
        ...new Map(starRatings.map((item) => [item["name"], item])).values(),
      ];

      this.starRatings = _.sortBy(starRatingunique, "name");
    },
    getuniqueforms(forms) {
      const formunique = [
        ...new Map(forms.map((item) => [item["name"], item])).values(),
      ];
      // formunique.sort(function (a, b) {
      //         return a - b;
      //       });
      this.form_unique = _.sortBy(formunique, "name"); //formunique;
      //console.log(this.form_unique, "<============formunique");
    },
    getuniqueCategories(categories) {
      const categoryunique = Array.from(new Set(categories));
      categoryunique.sort(function (a, b) {
        return a - b;
      });
      // const categoryunique = [
      //   ...new Map(categories.map((item) => {
      //     console.log("item in unique categoryunique", item);
      //     [item["name"], item]
      //   })).values(),
      // ];
      // const categoryunique = categories;
      // console.log("line 3487 unique cat : ", categoryunique);
      this.categories = categoryunique;
    },
    getuniquescoreTags(scoreTags) {
      const scoreTagunique = [
        ...new Map(scoreTags.map((item) => [item["name"], item])).values(),
      ];
      // //console.log("topic.score_tag", scoreTagunique);
      this.scoreTags = _.sortBy(scoreTagunique, "name");
    },
    async getdatastudioTopics() {
      // var topics = store.getters.getdatastudioTopics;
      // if (topics.length == 0) {
      this.isLoading = true;
      var partner_ids = this.partner_ids;
      var topics = [];
      // console.log(partner_ids, " :::::::::: partner_ids in topics");
      await store.dispatch("getdatastudioTopics", partner_ids).then(() => {
        topics = store.getters.getdatastudioTopics;
        //console.log("store.getters.getdatastudioTopics ::: ", store.getters.getdatastudioTopics);
        // this.getuniqueTopics(topics);
        this.topics_data = topics;
        this.topicsArray = topics;
        // // //console.log("topics.length", topics.length);
        // var topics_sorted = _.sortBy(topics, "category_name");

        return;
      });
      // } else {
      //   this.topics_data = topics;
      //   this.topicsArray = topics;
      //   //console.log("store.getters.getdatastudioTopics11 ::: ", topics);
      //   this.getuniqueTopics(topics);

      //   return;
      // }
    },
    async getCategoryNameTopics() {
      // var topics = store.getters.getdatastudioTopics;
      // if (topics.length == 0) {
      var partner_ids = this.partner_ids;
      this.isLoading = true;
      await store.dispatch("getCategoryNameTopics", partner_ids).then(() => {
        var topics = store.getters.getdatastudioTopics;
        //console.log("store.getters.getdatastudioTopics ::: ", store.getters.getdatastudioTopics);
        // this.getuniqueTopics(topics);
        // console.log("topics category_name ", topics);
        // this.topics_data = topics;
        // this.topicsArray = topics;
        // //console.log("topics.length", topics.length);
        const topicsunique = [
          ...new Map(
            topics.map((item) => [item["category_name"], item])
          ).values(),
        ];

        //  console.log("topics category_name111111 ", topicsunique);

        this.topics = _.sortBy(topicsunique, "category_name");
        // this.topics = topics;
        this.topicsArray = _.sortBy(topicsunique, "category_name");

        var topics_sorted = _.sortBy(topics, "category_name");

        return;
      });
      // } else {
      //   this.topics_data = topics;
      //   this.topicsArray = topics;
      //   //console.log("store.getters.getdatastudioTopics11 ::: ", topics);
      //   this.getuniqueTopics(topics);

      //   return;
      // }
    },
    getuniqueTopics(topics) {
      const topicsunique = [
        ...new Map(
          topics.map((item) => [item["category_name"], item])
        ).values(),
      ];

      this.topics = _.sortBy(topicsunique, "category_name");
      // this.topics = topics;
      this.topicsArray = _.sortBy(topicsunique, "category_name");

      //console.log("topics ::::::::: ",topicsunique);
    },

    apex_dataConfig() {
      this.apex_dataconfig_data = {
        dataSource: this.apex_data,
      };
    },
    apex_f_dataConfig() {
      this.apex_f_dataconfig_data = {
        dataSource: this.apex_f_data,
      };
    },
    apex_radar_dataConfig() {
      this.apex_dataconfig_data_radar = {
        dataSource: this.apex_data_radar,
      };
    },
    getapexData(result_monthdata) {
      // console.log("result_monthdata apex ========", result_monthdata);

      var dataset_apexchart = [];
      var backgroundColor = [
        "#5700ff",
        "#b08fff",
        "#D3C5FF",
        "#7c7c7c",
        "#3d3d3d",
        "#eeff41",
        "#FAFF99",
        "#CCCCCC",
      ];
      var hoverBackgroundColor = [
        "#5700ff",
        "#b08fff",
        "#D3C5FF",
        "#7c7c7c",
        "#3d3d3d",
        "#eeff41",
        "#FAFF99",
        "#CCCCCC",
      ];
      this.categories.sort();
      // console.log("this.categories ", this.categories, this.apexdata_label);
      this.categories.forEach((category, index) => {
        if (category.split(" ")[1] === "Time") {
          backgroundColor[index] = "#eeff41";
          hoverBackgroundColor[index] = "#eeff41";
        }
        if (category.split(" ")[1] === "Price") {
          backgroundColor[index] = "#3d3d3d";
          hoverBackgroundColor[index] = "#3d3d3d";
        }
        if (category.split(" ")[1] === "Place") {
          backgroundColor[index] = "#D3C5FF";
          hoverBackgroundColor[index] = "#D3C5FF";
        }
        if (category.split(" ")[1] === "Location") {
          backgroundColor[index] = "#b08fff";
          hoverBackgroundColor[index] = "#b08fff";
        }
        if (category.split(" ")[1] === "Brand") {
          backgroundColor[index] = "#5700ff";
          hoverBackgroundColor[index] = "#5700ff";
        }
        if (category.split(" ")[1] === "Products") {
          backgroundColor[index] = "#7c7c7c";
          hoverBackgroundColor[index] = "#7c7c7c";
        }
        if (category.split(" ")[1] === "Staff") {
          backgroundColor[index] = "#CCCCCC";
          hoverBackgroundColor[index] = "#CCCCCC";
        }
        if (category === "Others") {
          backgroundColor[index] = "#FAFF99";
          hoverBackgroundColor[index] = "#FAFF99";
        }

        // console.log(
        //   "category name :::: ",
        //   category.split(" ")[1],
        //   backgroundColor[index]
        // );
        // console.log(
        //   "backgroundColor[index], scoretag ::: ",
        //   backgroundColor[index]
        // );

        this.isLoading_apex_data = true;
        var apexdata = [];
        this.apexdata_label.forEach((month) => {
          // //console.log("month in apexdata $$$$$$$$$$", month);
          var count = 0;
          var avg_star_rating = 0;
          var star_rating = 0;
          result_monthdata.forEach((item) => {
            if (
              month === item["review_create_time:month"] &&
              category == item.category_id[1]
            ) {
              // console.log(" category ::: item.category_name :: " ,category , item.month ,item.sum_avg_star_rating);
              count = item.count;
              star_rating = item.review_star_rating_avg;
              if (star_rating === 0 && count == 0) {
                avg_star_rating = 0;
              } else {
                avg_star_rating = star_rating / count;
              }
            }
          });
          // //console.log("avg_star_rating ::::::::",star_rating, count,avg_star_rating ?0:avg_star_rating);
          // //console.log("item for each month :: ", month, scoretag.name, count);

          apexdata.push(parseFloat(star_rating.toFixed(2)));
        });
        // console.log("apex_data123 =========> ", apexdata);
        dataset_apexchart.push({
          data: apexdata,
          name: category,
        });
        //console.log("category in apexdata  $$$$$$$$$$", apexdata , category, index ,backgroundColor[index], hoverBackgroundColor[index] );
        //
      });
      // dataset_apexchart.push({
      //     data: [4,5],
      //     name: "brit",
      //   });
      // dataset_apexchart.push({
      //     data: [5,3],
      //     name: "sce",
      //   });
      // this.apexdata_label.push("decembre 2020");
      //  console.log("dataset_apexchart ==== line 2490 :::", dataset_apexchart, dataset_apexchart.length);

      this.dataset_apexchart = dataset_apexchart;
      // console.log("info-", "apex", this.dataset_apexchart, this.apexdata_label);

      //  console.log("this.apexdata_label :::: ", this.apexdata_label);
      // if (dataset_apexchart.length >0){
      // console.log("this.dataset_apexchart in cor graph  ::::", dataset_apexchart );
      this.apex_data = {
        series: dataset_apexchart,
        type: "bar",
        chartOptions: {
          chart: {
            type: "bar",
            height: 400,
            stacked: true,
            toolbar: {
              show: true,
            },
            zoom: {
              enabled: true,
            },
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                legend: {
                  position: "bottom",
                  offsetX: -10,
                  offsetY: 0,
                },
              },
            },
          ],
          plotOptions: {
            bar: {
              horizontal: false,
            },
          },
          xaxis: {
            type: "String",
            categories: this.apexdata_label,
          },
          colors: backgroundColor,

          fill: {
            colors: backgroundColor,
          },
          dataLabels: {
            style: {
              colors: backgroundColor,
            },
          },
          markers: {
            colors: hoverBackgroundColor,
          },
          // grid: {
          //     row: {
          //       colors: ['#5700ff','#eeff41','#3d3d3d','#7c7c7c','#b08fff','#D3C5FF','#FAFF99','#CCCCCC']
          //     },
          //     column: {
          //       colors: ['#5700ff','#eeff41','#3d3d3d','#7c7c7c','#b08fff','#D3C5FF','#FAFF99','#CCCCCC']
          //     }
          //   },
          legend: {
            show: true,
            position: "top",
            offsetY: 20,
          },
          fill: {
            opacity: 1,
          },
        },
      };

      this.isLoading_apex_data = false;
      this.apex_dataConfig();
      // }
      // if(this.dataset_apexchart){
      //   //  console.log("dataset_apexchart", dataset_apexchart);
      // }
    },
    getapexradarData(result_monthdata) {
      // console.log("result_monthdata apex11111 ========", result_monthdata);

      var dataset_apexchart_radar = [];
      var backgroundColor = [
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
      ];
      var hoverBackgroundColor = [
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
        "#3d3d3d",
      ];

      var apexdata_radar = [];
      var category_name = [];
      // this.apexdata_radar_label.forEach((category, index) => {

      //       if(category.split(" ")[1] === 'Time')
      //         {
      //           backgroundColor[index]="#eeff41"
      //           hoverBackgroundColor[index]="#eeff41"
      //         }
      //       if(category.split(" ")[1] === 'Price')
      //         {
      //           backgroundColor[index]="#3d3d3d"
      //           hoverBackgroundColor[index]="#3d3d3d"
      //         }
      //       if(category.split(" ")[1] === 'Place')
      //         {
      //           backgroundColor[index]="#D3C5FF"
      //           hoverBackgroundColor[index]="#D3C5FF"
      //         }
      //       if(category.split(" ")[1] === 'Location')
      //         {
      //           backgroundColor[index]="#b08fff"
      //           hoverBackgroundColor[index]="#b08fff"
      //         }
      //       if(category.split(" ")[1] === 'Brand')
      //         {
      //           backgroundColor[index]="#5700ff"
      //           hoverBackgroundColor[index]="#5700ff"
      //         }
      //       if(category.split(" ")[1] === 'Products'){
      //         backgroundColor[index]="#7c7c7c"
      //         hoverBackgroundColor[index]="#7c7c7c"
      //       }
      //       if(category.split(" ")[1] === 'Staff'){
      //         backgroundColor[index]="#CCCCCC"
      //         hoverBackgroundColor[index]="#CCCCCC"
      //       }
      //       if(category === 'Others'){
      //         backgroundColor[index]="#FAFF99"
      //         hoverBackgroundColor[index]="#FAFF99"
      //       }
      //     });
      // this.categories.forEach(()=>{
      //     apexdata_radar.push(0);
      // })
      // this.categories.forEach((category, index) => {
      // this.apexdata_radar_label.forEach((month)=>{
      // //console.log("month in apexdata $$$$$$$$$$", month);
      var count = 0;
      var star_rating = 0;
      var avg_star_rating = 0;
      // var apexdata_radar =[];
      result_monthdata.forEach((item) => {
        // if ((month === moment(item.month).format('MMM YYYY')) && (category == item.category_name)){
        // if (category == item.category_name) {
        // //console.log(" category ::: item.category_name :: " ,category , item.month ,item.sum_avg_star_rating);
        // count = item.count;
        // star_rating = item.sum_avg_star_rating;
        // if (star_rating === 0 && count == 0) {
        //   avg_star_rating=0;
        // } else {
        //   avg_star_rating = star_rating / count;
        // }
        // console.log("category , item.category_id[1] :: ", category ,item.review_star_rating_avg, item.category_id[1]);
        // if(category === item.category_id[1]){
        avg_star_rating = item.review_star_rating_avg;
        // }

        // }
        apexdata_radar.push(parseFloat(avg_star_rating.toFixed(2)));
        // category_name.push(item.category_id[1]);
      });
      // apexdata_radar[index]=parseFloat(avg_star_rating.toFixed(2));
      // console.log("item in result_monthdata  3892:::", apexdata_radar, category);
      // console.log(
      //   "avg_star_rating ::::::::",
      //   star_rating,
      //   count,
      //   avg_star_rating ? 0 : avg_star_rating
      // );
      // category_name.push(category);

      // //console.log("item for each month :: ", month, scoretag.name, count);

      // category.push(category);
      // });
      // //console.log("category in apexdata radar  $$$$$$$$$$", apexdata , category, index ,backgroundColor[index], hoverBackgroundColor[index] );
      //
      // console.log("dataset_apexchart radar ==== ", apexdata_radar[index], dataset_apexchart_radar);
      dataset_apexchart_radar.push({
        data: apexdata_radar,
        name: "Star Rating",
      });
      // });
      //  console.log("this.categories ::: ", category_name);
      this.dataset_radar_apexchart = dataset_apexchart_radar;
      // console.log("this.apexdata_radar_label::::::", dataset_apexchart_radar, this.apexdata_radar_label);
      this.apex_data_radar = {
        series: dataset_apexchart_radar,
        type: "radar",
        chartOptions: {
          chart: {
            type: "radar",
            height: 300,
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                legend: {
                  position: "bottom",
                  offsetX: -10,
                  offsetY: 0,
                },
              },
            },
          ],
          xaxis: {
            type: "String",
            categories: this.apexdata_radar_label,
          },
          yaxis: {
            min: 0,
            max: 5,
            tickAmount: 5
          },
          colors: backgroundColor,

          fill: {
            colors: backgroundColor,
          },
          dataLabels: {
            enabled: true,
            style: {
              colors: backgroundColor,
            },
          },
          markers: {
            colors: hoverBackgroundColor,
          },
          // grid: {
          //     row: {
          //       colors: ['#5700ff','#eeff41','#3d3d3d','#7c7c7c','#b08fff','#D3C5FF','#FAFF99','#CCCCCC']
          //     },
          //     column: {
          //       colors: ['#5700ff','#eeff41','#3d3d3d','#7c7c7c','#b08fff','#D3C5FF','#FAFF99','#CCCCCC']
          //     }
          //   },
          legend: {
            position: "top",
            offsetY: 20,
          },
          fill: {
            opacity: 0.1,
          },
        },
      };
      this.apex_radar_dataConfig();
    },
    barchartdata(result_monthdata) {
      // console.log("this.barchartscoredata_label ,this.barchartscoredata", this.barchartscoredata_label, result_monthdata);

      var dataset_barchart = [];
      var backgroundColor = [
        "#5700ff",
        "#b08fff",
        "#D3C5FF",
        "#7c7c7c",
        "#3d3d3d",
        "#eeff41",
        "#FAFF99",
        "#CCCCCC",
      ];
      var hoverBackgroundColor = [
        "#5700ff",
        "#b08fff",
        "#D3C5FF",
        "#7c7c7c",
        "#3d3d3d",
        "#eeff41",
        "#FAFF99",
        "#CCCCCC",
      ];
      // console.log("this.scoreTags ::: ", this.scoreTags);
      var scoretag_sorted = _.sortBy(this.scoreTags, "name").reverse();
      // console.log("scoretag_sorted ::: ", scoretag_sorted);
      scoretag_sorted.forEach((scoretag, index) => {
        var bardata = [];
        if (scoretag.name === "N") {
          backgroundColor[index] = "#7c7c7c";
          hoverBackgroundColor[index] = "#7c7c7c";
        }
        if (scoretag.name === "N+") {
          backgroundColor[index] = "#eeff41";
          hoverBackgroundColor[index] = "#eeff41";
        }
        if (scoretag.name === "NEU") {
          backgroundColor[index] = "#3d3d3d";
          hoverBackgroundColor[index] = "#3d3d3d";
        }
        if (scoretag.name === "NONE") {
          backgroundColor[index] = "#D3C5FF";
          hoverBackgroundColor[index] = "#D3C5FF";
        }
        if (scoretag.name === "P") {
          backgroundColor[index] = "#b08fff";
          hoverBackgroundColor[index] = "#b08fff";
        }
        if (scoretag.name === "P+") {
          backgroundColor[index] = "#5700ff";
          hoverBackgroundColor[index] = "#5700ff";
        }
        if (!scoretag.name) {
          backgroundColor[index] = "#CCCCCC";
          hoverBackgroundColor[index] = "#CCCCCC";
        }
        // console.log(
        //   "backgroundColor[index], scoretag ::: ",
        //   backgroundColor[index],
        //   scoretag.name
        // );

        // this.barchartscoredata_label = [...new Set(this.barchartscoredata_label)] ;

        this.barchartscoredata_label.forEach((month) => {
          // console.log("month in barchartscoredata $$$$$$$$$$", month);
          var count = 0;
          result_monthdata.forEach((item) => {
            //  console.log("month === moment(item.month).forma && scoretag.name == item.score_tag ", month , item.month, scoretag,item);
            if (month === item.month && scoretag.name == item.score_tag) {
              count += item.count;
            }
          });
          // console.log("item for each month :: ", month, scoretag.name, count);
          if (scoretag.name !== false) {
            bardata.push(count);
          }
        });
        // //console.log("scoretag in barchartscoredata  $$$$$$$$$$", scoretag.name, index ,backgroundColor[index], hoverBackgroundColor[index]);
        //  console.log("bardata ::: ", bardata);
        dataset_barchart.push({
          label: scoretag.name,
          data: bardata,
          backgroundColor: backgroundColor[index],
          hoverBackgroundColor: hoverBackgroundColor[index],
          hoverBorderWidth: 0,
        });
        // console.log("dataset_barchart ::: ", dataset_barchart);
        //
      });
      // console.log(
      //   "backgroundColor ::: ",
      //   this.barchartscoredata_label,
      //   backgroundColor,
      //   dataset_barchart
      // );

      // this.barchartDatacollection = {
      //   labels: this.barchartscoredata_label,
      //   datasets: dataset_barchart,
      //   // options: {
      //   //   scales: {
      //   //     xAxes: [
      //   //       {
      //   //         stacked: true,
      //   //         // gridLines: { display: true }
      //   //       },
      //   //     ],
      //   //     yAxes: [
      //   //       {
      //   //         stacked: true,
      //   //       },
      //   //     ],
      //   //   },
      //   //   legend: { display: true },
      //   //   // height: "100%",
      //   //   // width: "100%"
      //   // },
      // };

      var backgroundColor = [
        "#5700ff",
        "#b08fff",
        "#D3C5FF",
        "#7c7c7c",
        "#3d3d3d",
        "#eeff41",
        "#FAFF99",
        "#CCCCCC",
      ];
      var hoverBackgroundColor = [
        "#5700ff",
        "#b08fff",
        "#D3C5FF",
        "#7c7c7c",
        "#3d3d3d",
        "#eeff41",
        "#FAFF99",
        "#CCCCCC",
      ];

      const LabelXData = this.barchartscoredata_label;
      const YColumnData = dataset_barchart.reduce((acc, item) => {
        return acc.concat({
          data: item.data,
          name: item.label,
        });
      }, []);

      this.apex_f_data = {
        series: YColumnData,
        type: "bar",
        chartOptions: {
          chart: {
            type: "bar",
            height: 400,
            stacked: true,
            toolbar: {
              show: true,
            },
            zoom: {
              enabled: true,
            },
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                legend: {
                  position: "bottom",
                  offsetX: -10,
                  offsetY: 0,
                },
              },
            },
          ],
          plotOptions: {
            bar: {
              horizontal: false,
            },
          },
          xaxis: {
            type: "String",
            categories: LabelXData,
          },
          colors: backgroundColor,

          fill: {
            colors: backgroundColor,
          },
          dataLabels: {
            style: {
              colors: backgroundColor,
            },
          },
          markers: {
            colors: hoverBackgroundColor,
          },
          // grid: {
          //     row: {
          //       colors: ['#5700ff','#eeff41','#3d3d3d','#7c7c7c','#b08fff','#D3C5FF','#FAFF99','#CCCCCC']
          //     },
          //     column: {
          //       colors: ['#5700ff','#eeff41','#3d3d3d','#7c7c7c','#b08fff','#D3C5FF','#FAFF99','#CCCCCC']
          //     }
          //   },
          legend: {
            show: true,
            position: "top",
            offsetY: 20,
          },
          fill: {
            opacity: 1,
          },
        },
      };

      //console.log("Info-", dataset_barchart, LabelXData, YColumnData);
      this.apex_f_dataConfig();
    },

    // ANCHOR get 10 best rating location
    async getTenBestRatingLocations() {
      var formdataCount = [];
      this.isLoading = true;
      var partner_ids = [];
      this.graph_TenBestLocationRatingLoader = true;
      if (this.locationSelected.length > 0) {
        if (
          this.locationSelected.length === this.partner_ids.length &&
          this.locationSelected[0] === this.partner_ids[0]
        ) {
          partner_ids = this.partner_ids;
        } else {
          //  console.log("check businessunit and partner id length not same");
          partner_ids = this.partner_ids;
          location_ids = this.locationSelected;
        }
      } else {
        partner_ids = this.partner_ids;
      }

      var payload = {
        partner_ids: partner_ids,
      };
      await store.dispatch("getTenBestRatingLocations", payload).then(() => {
        formdataCount = store.getters.getTenBestRatingLocations;
        // alert("getTenBestRatingLocations");
        this.tenBestRaingLocations = formdataCount;
        this.graph_TenBestLocationRatingLoader = false;
        return;
      });
    },
    // ANCHOR Fn get 10 worst rating location
    async getTenWorstRatingLocations() {
      var formdataCount = [];
      this.isLoading = true;
      var partner_ids = [];

      this.graph_TenWorstLocationRatingLoader = true;
      if (this.locationSelected.length > 0) {
        if (
          this.locationSelected.length === this.partner_ids.length &&
          this.locationSelected[0] === this.partner_ids[0]
        ) {
          partner_ids = this.partner_ids;
        } else {
          //  console.log("check businessunit and partner id length not same");
          partner_ids = this.partner_ids;
          location_ids = this.locationSelected;
        }
      } else {
        partner_ids = this.partner_ids;
      }

      var payload = {
        partner_ids: partner_ids,
      };
      await store.dispatch("getTenWorstRatingLocations", payload).then(() => {
        formdataCount = store.getters.getTenWorstRatingLocations;
        this.tenWorstRaingLocations = formdataCount;
        this.graph_TenWorstLocationRatingLoader = false;
        return;
      });
    },
    // ANCHOR Fn Table green red mark data
    async getTableGreenRedMarkData() {
      var formdataCount = [];
      this.isLoading = true;
      var partner_ids = [];
      var create_date = [];
      var location_ids = [];

      if (this.range !== null && this.range.length > 0) {
        if (this.range[0] !== null) {
          var start = moment(this.range[0]).format("YYYY-MM-DD");
          var end = moment(this.range[1]).format("YYYY-MM-DD");
          create_date.push(start);
          create_date.push(end);
        }
      }

      if (this.locationSelected.length > 0) {
        if (
          this.locationSelected.length === this.partner_ids.length &&
          this.locationSelected[0] === this.partner_ids[0]
        ) {
          partner_ids = this.partner_ids;
        } else {
          //  console.log("check businessunit and partner id length not same");
          partner_ids = this.partner_ids;
          location_ids = this.locationSelected;
        }
      } else {
        partner_ids = this.partner_ids;
      }

      var starRatings = [];
      if (this.starratingSelectedValue.length > 0) {
        starRatings = this.starratingSelectedValue;
      }

      var scoreTags = [];
      if (this.scoretagSelected.length > 0) {
        this.scoretagSelected.forEach((score_tag) => {
          scoreTags.push(score_tag.name);
        });
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        create_date: create_date,
        scoreTags: scoreTags,
        starRatings: starRatings,
      };
      //console.log("info-", "payload", payload);
      this.tableGreenRedMarkDataLoading = true;
      this.tableGreenRedMarkDataValues = [];
      await store.dispatch("getTableGreenRedMarkData", payload).then(() => {
        formdataCount = store.getters.getTableGreenRedMarkData;
        this.tableGreenRedMarkData = formdataCount;
        return;
      });
    },
  },
  watch: {
    partnerSelected: function (partnerSelected) {
      var partner_ids = [];
      //  partnerSelected.forEach((partner) => {
      if (partnerSelected !== null) {
        partner_ids.push(partnerSelected.id);
      }
      //   partner_ids.push(partner.id);
      // });
      //  console.log("partner selected", partnerSelected, partner_ids);
      this.locationSelected = [];
      this.insights = [];
      this.insightsArray = [];
      this.offset_insight = 0;

      // this.partnerSelected = "";
      this.scoretagSelected = "";
      this.starratingSelected = "";
      this.topicSelected = "";

      if (partner_ids.length > 0) {
        partner_ids = partner_ids;
        this.partner_ids = partner_ids;
        this.getlocation();
        this.getlocationbyBestPartner();
        this.getlocationbyWorstPartner();
        
        // this.getBusinessUnits();
        this.getscoretagcommentCount();
        this.getsentimentanalysisCount();
        this.getstarRatingandCommentData();
        this.getscoretagratingovertime();
        this.getcategoryratingovertime();
        this.gettopicstarratingCount();
        this.gettopicavgstarratingCount();
        this.getformdataCount();
        this.getTenBestRatingLocations();
        this.getTenWorstRatingLocations();
        this.getTableGreenRedMarkData();
        // this.getstarRating();
        // this.getCategoryNameTopics();
        // this.getdatastudioSentiment();
        // this.getdatastudioTopics();

        // this.getanalyzeInsightFirst();
        // this.getanalyzeInsightThird();
        // this.getanalyzeInsightFourth();
        // this.getanalyzeInsightFifth();
      } else {
        this.locations = [];
        this.locationSelected = [];
        this.businessunitSelected = [];
        this.businessUnits = [[]];
        this.scoretagcommentCount = [];
        this.offset_insight = 0;
        this.starRatingandCommentData = [];

        this.score_data = [];
        this.insights = [];
        this.category = [];
        this.barchartscoredata_label = [];
        this.barchartDatacollection.label = [];
        this.apexdata = [];
        this.apex_dataconfig_data = {
          dataSource: {
            type: "bar",
            chartOptions: {
              chart: {
                type: "bar",
                height: 300,
                stacked: true,
                toolbar: {
                  show: true,
                },
                zoom: {
                  enabled: true,
                },
              },
            },
          },
        };
        this.apex_f_dataconfig_data = {
          dataSource: {
            type: "bar",
            chartOptions: {
              chart: {
                type: "bar",
                height: 300,
                stacked: true,
                toolbar: {
                  show: true,
                },
                zoom: {
                  enabled: true,
                },
              },
            },
          },
        };
        this.apex_dataconfig_data_radar = {
          dataSource: {
            type: "radar",
            chartOptions: {
              chart: {
                type: "radar",
                height: 300,
              },
            },
          },
        };
        this.barchartDatacollection = { labels: [], datasets: [], options: {} };
        this.topic_avg_starrating_data = [];

        this.dataset_apexchart = [];

        this.apexdata_label = [];
        this.barchartscoredata_label = [];
        this.form_count_data = [];
        this.topic_form_data = [];
        this.topic_starrating_data = [];

        // this.demographicExcludeSelected=[];
        this.starRatings = [];
        this.scoreTags = [];
        this.topics = [];
        this.starratingSelected = [];
        this.topicSelected = "";
        this.locationBestPartnerData = [];
        this.locationWorstPartnerData = [];
        this.tableGreenRedMarkData = [];
        this.tableGreenRedMarkDataLoading = false;
      }
    },
    score_data: function (data) {
      // ANCHOR Sentimental Grap Calculation
      let sentiMentalGraphInputData = [];
      let xLabels = [];
      let yBarColumn = [];
      let yBarPercentSplineColumn = [];

      if (data && data.length) {
        sentiMentalGraphInputData = _.sortBy(data, "score_tag").reverse();
        xLabels = sentiMentalGraphInputData.reduce((acc, result) => {
          return acc.concat(result.score_tag);
        }, []);
        yBarColumn = sentiMentalGraphInputData.reduce((acc, result) => {
          return acc.concat(result.__count);
        }, []);
        const totalOfBarsColumn = yBarColumn.reduce((acc, item) => {
          return acc + (item - 1);
        }, 0);
        yBarPercentSplineColumn = yBarColumn.reduce((acc, item) => {
          return acc.concat(
            parseFloat(((item / totalOfBarsColumn) * 100).toFixed(2))
          );
        }, []);
      }
      this.graph_barChartSentimentAnalysisSpline.xAxis[0].categories = xLabels;
      this.graph_barChartSentimentAnalysisSpline.series[0].data = yBarColumn;
      this.graph_barChartSentimentAnalysisSpline.series[1].data =
        yBarPercentSplineColumn;
    },
    // ANCHOR form_count word cloud watcher
    form_count_data: function (data) {
      let wordCloudListSeries = [];
      let formatData = [];
      if (data) {
        formatData = data.reduce((acc, item) => {
          return acc.concat({
            name: item.Form,
            weight: item.__count,
          });
        }, []);
        wordCloudListSeries = _.sortBy(formatData, "weight").reverse();
      }
      this.graph_wordcloud.series[0].data = wordCloudListSeries;
    },

    // ANCHOR watch ten best rating locations
    tenBestRaingLocations: function (data) {
      let xAxisData = 0;
      let yAxisData = 0;
      let ySplineAxisData = 0;
      if (data) {
        xAxisData = data.reduce((acc, item) => {
          return acc.concat(item.category_id[1]);
        }, []);
        yAxisData = data.reduce((acc, item) => {
          return acc.concat(parseFloat(item.location_rating.toFixed(2)));
        }, []);
        ySplineAxisData = data.reduce((acc, item) => {
          return acc.concat(parseFloat(item.review_star_rating_avg.toFixed(2)));
        }, []);
      }
      this.graph_TenBestLocationRating.xAxis[0].categories = xAxisData;
      this.graph_TenBestLocationRating.series[0].data = yAxisData;
      this.graph_TenBestLocationRating.series[1].data = ySplineAxisData;
    },
    // ANCHOR watch ten best rating locations
    tenWorstRaingLocations: function (data) {
      //console.log("info-", "tenWorstRaingLocations", data);
      let xAxisData = 0;
      let yAxisData = 0;
      let ySplineAxisData = 0;
      if (data) {
        xAxisData = data.reduce((acc, item) => {
          return acc.concat(item.category_id[1]);
        }, []);
        yAxisData = data.reduce((acc, item) => {
          return acc.concat(parseFloat(item.location_rating.toFixed(2)));
        }, []);
        ySplineAxisData = data.reduce((acc, item) => {
          return acc.concat(parseFloat(item.review_star_rating_avg.toFixed(2)));
        }, []);
      }
      this.graph_TenWorstLocationRating.xAxis[0].categories = xAxisData;
      this.graph_TenWorstLocationRating.series[0].data = yAxisData;
      this.graph_TenWorstLocationRating.series[1].data = ySplineAxisData;
    },
    // ANCHOR watch table green red mark data
    tableGreenRedMarkData: function (data) {
      let locationName = [];
      let loacationReviewCount = [];
      var loacationCategory = [];
      var loacationUniqSortCategoryName = [];
      if (data) {
        locationName = data.reduce((acc, item) => {
          return acc.concat(item.location_id[1]);
        }, []);
        locationName = _.uniq(locationName);
        // Location review count
        locationName.forEach((loc_name, i) => {
          var tempLocationCat = {};
          data.forEach((item, j) => {
            if (loc_name == item.location_id[1]) {
              loacationReviewCount[i] = item.location_review_count;
              loacationUniqSortCategoryName.push(item.category_id[1]);
              tempLocationCat = {
                ...tempLocationCat,
                [item.category_id[1]]: parseFloat(
                  item.review_star_rating_avg
                ).toFixed(2),
              };
            }
          });

          if (tempLocationCat) {
            loacationCategory[i] = tempLocationCat;
          }
        });
        // Unique Sort Cat Name
        loacationUniqSortCategoryName = _.uniq(loacationUniqSortCategoryName);
        loacationUniqSortCategoryName = _.sortBy(loacationUniqSortCategoryName);

        // Loop by sort cat array and create array for all cat else 0
        loacationCategory.forEach((item, i) => {
          var localArray = [];
          var localArrayValue = [];
          var catObj = {};
          loacationUniqSortCategoryName.forEach((cat) => {
            if (item[cat]) {
              localArray.push(cat.toLowerCase());
              localArrayValue.push(item[cat]);
            }
            const tempObj = item[cat]
              ? {
                  [cat.toLowerCase()]: item[cat],
                }
              : {
                  [cat.toLowerCase()]: 0,
                };
            catObj = {
              ...catObj,
              ...tempObj,
            };
          });
          // Median Calculation
          const localArrayLength = localArray.length;
          
          // console.log(
          //   "info-",
          //   "mid",
          //   localArray,
          //   localArrayLength,
          //   localArrayLength % 2
          // );
          
            let colorCoding = {};
            localArrayValue.forEach((it, i) => {
              if (it < 2.5) {
                colorCoding = {
                  ...colorCoding,
                  [localArray[i]]: "dt-red-l",
                };
              } else {
                colorCoding = {
                  ...colorCoding,
                  [localArray[i]]: "dt-green-l",
                };
              }
            });
            catObj = {
              ...catObj,
              ["_cellClasses"]: {
                ...colorCoding,
              },
            };
          

          loacationCategory[i] = catObj;
        });

        // console.log(
        //   "info-",
        //   "$tableGreenRedMarkData",
        //   // data,
        //   locationName,
        //   loacationUniqSortCategoryName,
        //   loacationCategory
        // );
        let dtBrandColumns = [];
        let dtDataColumns = [];
        loacationUniqSortCategoryName.forEach((item) => {
          dtBrandColumns = [
            ...dtBrandColumns,
            {
              key: item.toLowerCase(),
              lable: item,
            },
          ];
        });
        this.tableGreenRedMarkColumnValues = [
          {
            key: "locname",
            label: "Location Name",
          },
          {
            key: "comments",
            label: "Comments",
          },
          ...dtBrandColumns,
        ];

        locationName.forEach((item, i) => {
          dtDataColumns = [
            ...dtDataColumns,
            {
              locname: item,
              comments: loacationReviewCount[i],
              ...loacationCategory[i],
            },
          ];
        });
        this.tableGreenRedMarkDataLoading = false;
        this.tableGreenRedMarkDataValues = dtDataColumns;
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.w-clip-chart {
  background: transparent;
}
.w-clip-chart .chart-cliped {
  width: 85%;
  margin: auto;
  border-radius: 100%;
  /* border: 1px solid #ccc; */
}
</style>
